import { useState, useEffect, useRef } from "react";
import { Modal, Spin, Row, DatePicker, Form, AutoComplete, Col, Popover, Table, Drawer, Button, Input, message, Tabs } from "antd";
import {
  CloseOutlined,
  CloseSquareFilled,
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  CodeSandboxOutlined,
  RightOutlined,
  DownOutlined,
  CalendarOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
import { Scrollbars } from "react-custom-scrollbars";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";
import db from "../../../database";
import styles from "../../../constants/styles.json";
import BarCodeComponentForRetail from "../../../lib/BarCodeComponentForRetail";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { useWindowDimensions } from "../../../lib/useViewport";
import CWPoleDisplay from "../../../lib/printer/CWPoleDisplay";
import PoleDisplay from "../../../lib/printer/poleDisplay";
import { useGlobalContext } from "../../../lib/auth/globalStore";
import { processSync } from "../../Sync/syncData";
import { useHistory } from "react-router-dom";
import ProductPanelSM from "../../../components/PointOfSale/Retail/productPanelSM";
import {
  discardCouponService,
  discardGiftCard,
  getProductsNearbyStockService,
  upsertGiftCardTransaction,
  verifyReturn,
  unlinkTill,
  upsertCreditTransaction,
  syncSingleProductByValue,
} from "../../../services";
import sideMenu from "../../../assets/images/side-menu.svg";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import LockIcon from "../../../assets/images/lock-icon.svg";
import userIcon from "../../../assets/images/userId.svg";
import Ofline from "../../../assets/images/red.svg";
import Online from "../../../assets/images/green.svg";
import Close from "../../../assets/images/close-x.svg";
import Logout from "../../../assets/images/logout-new.svg";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import ScanIcon from "../../../assets/images/scanIcon.svg";
import FilterIcon from "../../../assets/images/filterNewICon.svg";
import NotesAdd from "../../../assets/images/note-add.svg";
import userTieIcon from "../../../assets/images/userTieIcon.svg";
import Offers from "../../../assets/images/promoTag.svg";
import NotesImage from "../../../assets/images/notes.svg";
import Hold from "../../../assets/images/pause-new.svg";
import Cancel from "../../../assets/images/cancel-new.svg";
import DeleteProduct from "../../../assets/images/delete1.svg";
import userAddIcon from "../../../assets/images/userAddIcon.svg";
import CustomerSearch from "../../../assets/images/c-serach.svg";
import CustomerIcon from "../../../assets/images/customer1.svg";
import View from "../../../assets/images/view.svg";
import AddUser from "../../../assets/images/userAdd.svg";
import SyncIcon from "../../../assets/images/syncIcon.svg";
import information from "../../../assets/images/information.svg";
import discount from "../../../assets/images/discount.svg";
import ReturnIcon from "../../../assets/images/return.svg";
import SalesHistoryIcon from "../../../components/PointOfSale/Retail/SvgComponent/SalesHistoryIcon";
import giftVoucher from "../../../assets/images/giftVoucher.svg";
import user_add from "../../../assets/images/user_add.svg";
import Back from "../../../assets/images/backIcon.svg";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import CancelArrow from "../../../assets/images/cancelArrow.svg";
import ticSelect from "../../../assets/images/tic.png";
import Loyality from "../../../assets/images/loyalityIcon.svg";
import UPI from "../../../assets/images/upiIcon.svg";
import Gift from "../../../assets/images/giftIcon.svg";
import Credit from "../../../assets/images/creditCardIcon.svg";
import cardType from "../../../assets/images/cardType.svg";
import creditNote from "../../../assets/images/creditNote.svg";
import LockScreen from "../../../assets/images/lockScreen.svg";
import unlinkTillIcon from "../../../assets/images/unlink-icon.svg";
import walletWhite from "../../../assets/images/walletWhite.png";
import POSIcon from "../../../components/PointOfSale/Retail/SvgComponent/POS";
import ParkedBillIcon from "../../../components/PointOfSale/Retail/SvgComponent/ParkedBill";
import CashManagementIcon from "../../../components/PointOfSale/Retail/SvgComponent/CashManagementIcon";
import ManagePreorder from "./ManagePreorder";
import RetailModals from "../../PointOfSale/Retail/RetailModals";
import Retrieve from "../../../assets/images/retrieve.png";
import GroupedProducts from "../../../lib/hooks/GroupedProducts";
import RenderInput from "../../../lib/hooks/RenderInput";
import { numberToWords } from "../../../utility/numberToWords";
import messages from "../../../errors/messages.en-IN.json";
import LoadingScreen from "../../PointOfSale/Retail/SuperMarket/LoadingScreen";
import leftLoading from "../../../assets/images/opo.gif";
import { clock } from "../../../utility/clock";
import { getWorkflowData } from "../../../utility/getWorkflowData";
import { useEventBus } from "../../../lib/hooks/EventBusProvider";

const SupermarketPreorder = (props) => {
  const {
    showSaleType,
    setIsSaleTypeFlag,
    selectedSaleType,
    tillData,
    clearProductSearchResults,
    setProductSearchInput,
    productSearchInput,
    setOpen,
    setInputName,
    setIsInputFocused,
    productSearchInputRef,
    onBarcodeInput,
    setIsProductsFilter,
    setFilterDrawer,
    documentTypes,
    selectedDocumentType,
    setSelectedDocumentType,
    setShowDocumentPopup,
    setNotesValue,
    selectedProductInCart,
    setSelectedProductInCart,
    selectProductInCart,
    showPaymentMethods,
    setShowPaymentMethods,
    selectedRowKeys,
    deleteProduct,
    setCustomMixItems,
    setGroupQty,
    setSelectedProductForNotes,
    setOpenSalesRep,
    realPrice,
    setRealPrice,
    setFirstInputValue,
    setSelectedCustomMix,
    setExistingGroupItems,
    setOverPayedAmount,
    overPayedAmount,
    amount,
    setAmount,
    setQtyNumberFlag,
    setStockList,
    stockList,
    keyboard,
    clearSelectedProductInCart,
    verifyStock,
    openDisplayParkedBillModal,
    filterDrawer,
    couponModalVisible,
    displayAddNewCustomer,
    validateGiftCard,
    displayCustomerSearch,
    displayEditOldCustomer,
    giftCardFlag,
    isGiftCardFlag,
    manualDiscountModalVisible,
    loyalityOtpModalVisible,
    cart,
    setDisplayCustomerSearch,
    setCloseCustomerFlag,
    setEditFlag,
    removeCutomer,
    showAddNewCustomerFields,
    showEditOldCustomerFields,
    manualDiscountForm,
    setManualDiscountInput,
    setSelectedManualDiscountTypeValue,
    setManualDiscountModalVisible,
    setIsGiftCardFlag,
    setAddToBagFlag,
    setGiftCardType,
    searchOrderHistory,
    modifyProductList,
    onChangeTotalQuantity,
    enterTotalQty,
    handleTotalQty,
    decreaseProductQty,
    increaseProductQty,
    handleRealPrice,
    enterRealPrice,
    showPayments,
    setShowPayments,
    setNumb,
    setIsCardPaymentFlag,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    paymentModalInputRef,
    processOrder,
    paymentCardRef,
    filteredPaymentMethods,
    isShowingAll,
    onChangeAmount,
    requestPayment,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    currenciesData,
    handleCashPayment,
    handleAmount,
    giftCardData,
    setGiftCardData,
    handleLoyaltyPayment,
    setCart,
    getFilteredPaymentMethods,
    setStartIndex,
    startIndex,
    setSelectedKeys,
    filterdParkedList,
    showOrderHistory,
    selectedSaleTypeData,
    checkIsManualWeight,
    setIsSearchProducts,
    getMoreProducts,
    isProductsFilter,
    getSearchedProducts,
    productListCardRef,
    isProductsVisible,
    setIsProductsVisible,
    pickProduct,
    setKeyboardType,
    keyboardType,
    productsData,
    setProductsData,
    setLayoutName,
    hasShownCustomerModalRef,
    orderType,
    deleteCart,
    documentSequence,
    setDocumnetSequence,
    setAddCashFlag,
    setCashAddInFlag,
    paymentModal,
    addCashFlag,
    setParkedBillSearchInput,
    searchParkedBill,
    parkedBillSearchInput,
    selectedKeys,
    selectParkedBill,
    upsertPOSLog,
    discardParkedBill,
    options,
    setOptions,
    searchInputRef,
    activeInput,
    setActiveInput,
    qtyInputRef,
    customMixItems,
    existingGroupItems,
    selectedCustomMix,
    setOrderType,
    groupQty,
    posSaleTypes,
    setPosSaleTypes,
    setCurrenciesData,
    deleteReceipt,
    calendarVisible,
    setCalendarVisible,
    selectedDate,
    setSelectedDate,
    closeProductPanel,
    isQtyUpdate,
    setProductStock,
    loading,
    setLoading,
    cardPaymnetStatus,
    setCardPaymnetStatus,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    metaDataRef,
    setTempCart,
    tempCart,
    showCompleteSaleStock,
    setShowCompleteSaleStock,
    completeSaleStockData,
    setCompleteSaleStockData,
    clearReturnCartData,
    walletFunc,
    PaymentMethods,
    syncLoad,
    setSyncLoad,
    setFilterdParkedList,
    mapParkedList,
    notesPopup,
    setNotesPopup,
    renderDeliveryDate,
    calendarContent,
    handleDateSelect,
    toggleCalendar,
    calendarVisibleMap,
    setCalendarVisibleMap,
    debounceRef,
    enterRef,
  } = props;
  const { globalStore, setGlobalStore } = useGlobalContext();
  const { dispatchEvent, dispatchItemSelection } = useEventBus();
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage } = globalStore;
  const { TabPane } = Tabs;
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const history = useHistory();
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const domainURL = process.env.REACT_APP_domain;
  const version_number = process.env.REACT_APP_release_no || "24Q0.0.0";
  const [tillLink, setTillLink] = useState(false);
  const productSearchRef = useRef(null);
  const productPanelSearchRef = useRef(null);
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [showCustomMix, setShowCustomMix] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isLocked, setIsLocked] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [isSectionVisible, setIsSectionVisible] = useState(false);
  const [showInputFields, setShowInputFields] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [showPreOrders, setShowPreOrders] = useState(false);
  const [productsDisplay, setProductDisplay] = useState("super-market");
  const [productsList, setProductsList] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [retrunSearchType, setReturnSearchType] = useState("orderNo");
  const [isCashMangement, setIsCashManagement] = useState(false);
  const [cashManagementData, setCashManagementData] = useState(false);
  const [keyValue, setKeyValue] = useState("0");
  const [isParkedBill, setIsparkedBill] = useState(false);
  const [tableValue, setTableValue] = useState("POS");
  const [parkedBill, setParkedBill] = useState();
  const [productMap, setProductMap] = useState({});
  const [groupName, setGroupName] = useState("Custom Mix");
  const [productArray, setProductArray] = useState();
  // const [calendarVisibleMap, setCalendarVisibleMap] = useState({});
  const [clock1, setClock1] = useState(clock());
  const selectBagRef = useRef(null);
  const realPriceRef = useRef(null);
  let parkedBillRef = useRef();
  const redirectUrl = process.env.REACT_APP_redirectURL;
  const { authHeaders } = getOAuthHeaders();
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const customerId = tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId;
  const tillAccessData = tillData?.tillAccess;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, [isLocked]);

  useEffect(() => {
    if (amount < 0 && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
      const cashMethod = showPayments.find((pm) => pm.name?.toLowerCase() === "cash");
      setSelectedPaymentMethod(cashMethod);
    }
  }, [amount]);

  useEffect(() => {
    if (cardPaymnetStatusPLB) {
      Modal.info({
        icon: null,
        // centered: true,
        okButtonProps: { style: { display: "none" } },
        okText: "Go Back",
        content: (
          <div
            style={{
              fontSize: "18px",
              fontWeight: "500",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: 0,
              fontSize: "1vw",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "58px",
                height: "58px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 165, 0, 0.2)",
                marginTop: "15px",
              }}
            >
              <ExclamationCircleOutlined
                style={{
                  fontSize: "35px",
                  color: "orange",
                }}
              />
            </div>
            <p style={{ color: "#0F0718", fontWeight: 550, fontSize: "1.8em", padding: "15px 15px 0 15px", marginBottom: 0 }}>Payment Timed Out</p>
            <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "5px 20px 0 20px" }}>
              Your payment request couldn't be processed in time. Please try again
            </p>

            <button
              style={{
                backgroundColor: "#2F3856",
                color: "#fff",
                // padding: "10px",
                padding: "10px 50px 10px 50px",
                borderRadius: "10px",
                border: "none",
                cursor: "pointer",
              }}
              onClick={() => {
                setCardPaymnetStatusPLB(false);
                Modal.destroyAll();
              }}
            >
              Try Again
            </button>
          </div>
        ),
        style: {
          textAlign: "center",
          height: "50vh",
          width: "50%",
        },
        modalRender: (modal) => <div style={{ borderRadius: "12px", overflow: "hidden" }}>{modal}</div>,
        bodyStyle: {
          padding: "0",
        },
        closable: false,
        onOk: null,
      });
    }
  }, [cardPaymnetStatusPLB]);

  useEffect(() => {
    setTimeout(() => {
      try {
        const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
        if (cartDetails !== null) {
          setCart(cartDetails);
        }
      } catch (error) {
        console.error("Error parsing cart details:", error);
      }
    }, 200);

    setTimeout(() => {
      setProductSearchInput("");
      const productSearchInput = document.getElementById("sm-product-search");
      if (productSearchInput) {
        productSearchInput.blur();
      }
      keyboard?.current?.setInput("");
    }, 200);
  }, []);
  const errorMessage = (modalTitle, modalContent) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
    });
  };

  useEffect(() => {
    if (isParkedBill) {
      setTimeout(() => {
        parkedBillRef.current.focus();
      }, 10);
    }
  }, [isParkedBill]);

  useEffect(async () => {
    filterdParkedList?.map((item, index) => {
      item.key = uuidv4().replace(/-/g, "").toUpperCase();
    });
    let data = await db.cashInCashOut.toArray();
    setCashManagementData(data);
    if (paymentModal === false) {
      setTimeout(() => {
        setKeyValue("0");
      }, 1000);
    }
  }, [addCashFlag, paymentModal]);

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long", // Full day name (e.g., Wednesday)
    day: "numeric", // Day of the month (e.g., 28)
    month: "long", // Full month name (e.g., June)
    year: "numeric", // Full year (e.g., 2023)
  })}`;

  const handleLogin = () => {
    if (isOnline) {
      const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());

      for (let i = 0; i < cookiesToDelete.length; i++) {
        const cookie = cookiesToDelete[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        const domain = "domain=" + domainURL;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
      }

      // }
      // localStorage.removeItem("tillSession")
      localStorage.setItem("locked", isLocked);
      const redirectWithIsLocked = `${redirectUrl}sign-in/?username=${authHeaders.username}&readOnly=true`;
      window.location.assign(redirectWithIsLocked);
    } else {
      errorMessage("Sync Failed", "Please check your network connection and try again");
    }
  };

  const onChangeParkedBill = (inputVal) => {
    setParkedBillSearchInput(inputVal);
    keyboard?.current?.setInput(inputVal);
  };

  const columns = [
    {
      title: "Parked Sale",
      dataIndex: "parkedTime",
      key: "parkedTime",
      width: "20%",
    },
    {
      title: "Document No",
      dataIndex: "parkedDocNo",
      key: "parkedDocNo",
      width: "25%",
    },
    {
      title: "Customer",
      dataIndex: "customer",
      key: "customer",
      width: "20%",
    },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
      width: "20%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "15%",
    },
  ];

  const handleExpandPerkedData = (record) => {
    const nextExpandedKeys = [...expandedRowKeys];
    const index = nextExpandedKeys.indexOf(record.key);
    if (index > -1) {
      nextExpandedKeys.splice(index, 1); // Collapse row if already expanded
    } else {
      nextExpandedKeys.push(record.key); // Expand row if not expanded
    }
    setExpandedRowKeys(nextExpandedKeys);
  };

  const retrieveParkedData = (record) => {
    if (cart.items.length > 0) {
      openDisplayParkedBillModal("retrieve", record);
    } else {
      selectParkedBill(record, "management");
    }
  };

  const discardMessage = (modalTitle, modalContent, record) => {
    Modal.confirm({
      title: modalTitle,
      content: modalContent,
      onOk: () => handleOk(record),
      autoFocusButton: null,
      onCancel: handleCancel,
    });
  };

  const processWithParkedBillCancellation = (record) => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    discardGiftCards(record.parkedCart);
    if (record?.parkedCart?.couponInput?.length > 0) {
      const serverUrl = process.env.REACT_APP_serverUrl;

      const couponsData = [...record.parkedCart.couponInput];
      // Function to discard a coupon
      const discardCoupon = async (coupon) => {
        const discardCouponQuery = {
          query: `query {
            discardCoupon(couponcode: "${coupon.couponCode}", referenceId: "${coupon.referenceId}") {
              status
              message
            }
          }`,
        };
        try {
          const response = await discardCouponService(coupon.couponCode, coupon.referenceId);
        } catch (error) {
          console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
        }
      };
      couponsData.forEach((coupon) => {
        discardCoupon(coupon);
      });
    }
    let index = record.parkedCart.payments.findIndex((payment) => payment.name.toLowerCase() === "loyalty" && !record.parkedCart.isReturn);
    if (index >= 0) {
      handleLoyaltyPayment(record.parkedCart.payments[index], record.parkedCart);
    }
    setGiftCardData([]);
    discardParkedBill(record);
    setParkedBillSearchInput("");

    // Refresh the parked bills list
    const allParkedList = JSON.parse(localStorage.getItem("parkedList")) || [];
    setFilterdParkedList(mapParkedList(allParkedList));
    const productSearchInput = document.getElementById("sm-product-search");
    if (productSearchInput) {
      setTimeout(() => {
        productSearchInput.focus();
      }, 300);
    }
  };

  const handleOk = async (record) => {
    let cartToDb = JSON.parse(localStorage.getItem("cartObj"));
    const { workflowRules, approvers } = await getWorkflowData();
    const cancelParkedBillRule = workflowRules.find((res) => res.eventName === "Cancel Parked Bill");
    if (cancelParkedBillRule) {
      dispatchEvent(cancelParkedBillRule.eventName, cancelParkedBillRule.ruleName, cancelParkedBillRule.ruleCondition, approvers, null, async (eventData) => {
        if (eventData?.approvalGranted) {
          await processWithParkedBillCancellation(record);
        } else {
          Modal.error({
            title: "Approval Required",
            content: "The cancellation request was not approved.",
          });
        }
      });
    } else {
      await processWithParkedBillCancellation(record);
    }
  };
  const showPreviousItems = () => {};

  const handleCancel = () => {
    Modal.destroyAll();
    const productSearchInput = document.getElementById("sm-product-search");
    if (productSearchInput) {
      setTimeout(() => {
        productSearchInput.focus();
      }, 300);
    }
  };

  const cancelOrder = async () => {
    let setAuthTokens;
    setSelectedDocumentType("Invoice");
    let PaymentMethods = getFilteredPaymentMethods() || [];
    let payments =
      PaymentMethods.length > 5
        ? _.sortBy(PaymentMethods, "sequenceNo").slice(
            0,
            tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
          )
        : PaymentMethods;

    setShowPayments(payments);
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    if (cart?.couponInput?.length > 0) {
      const serverUrl = process.env.REACT_APP_serverUrl;

      const couponsData = [...cart.couponInput];
      // Function to discard a coupon
      const discardCoupon = async (coupon) => {
        const discardCouponQuery = {
          query: `query {
                  discardCoupon(couponcode: "${coupon.couponCode}", referenceId: "${coupon.referenceId}") {
                    status
                    message
                  }
                }`,
        };
        try {
          const response = await discardCouponService(coupon.couponCode, coupon.referenceId);

          console.log(`Coupon ${coupon.couponCode} discarded:`, response.data);
        } catch (error) {
          console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
        }
      };
      couponsData.forEach((coupon) => {
        discardCoupon(coupon);
      });
    }

    discardGiftCards(cart);
    let index = cart.payments.findIndex((payment) => payment.name.toLowerCase() === "loyalty" && !cart.isReturn);
    if (index >= 0) {
      handleLoyaltyPayment(cart.payments[index], cart);
    }
    clearCart(cart.type);
    hasShownCustomerModalRef.current = false;
    // const productSearchInput = document.getElementById("sm-product-search");
    // if (productSearchInput) {
    //   setTimeout(() => {
    //     productSearchInput.focus();
    //   }, 300);
    // }
    localStorage.removeItem("couponAdditionalInfo");
    setShowInputFields(false);
    setCustomMixItems([]);
    setGroupQty(1);
    setActiveInput("search");
    setProductSearchInput("");
    if (searchInputRef?.current) {
      searchInputRef.current.focus();
    }
  };

  const deleteProductModal = () => {
    const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";
    const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj") || "{}");
    const activeCart = isExchange && exchangeCartObj?.items?.length > 0 ? exchangeCartObj : cart;
    if (activeCart?.payments?.length > 0) {
      message.warning(`${messages.errors.cart.delete_payment_first}`);
      return;
    }
    if (activeCart?.items?.length > 0) {
      Modal.confirm({
        title: "This action will remove all products from the cart, including the selected customer.Do you wish to proceed?",
        icon: null,
        cancelText: "No",
        okText: "Yes",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        async onOk() {
          const { workflowRules, approvers } = await getWorkflowData();
          const cancelParkedBillRule = workflowRules.find((res) => res.eventName === "Cancel Parked Bill");
          if (cancelParkedBillRule && activeCart?.parked === "Y" && activeCart?.isRetrived === "Y") {
            dispatchEvent(cancelParkedBillRule.eventName, cancelParkedBillRule.ruleName, cancelParkedBillRule.ruleCondition, approvers, null, async (eventData) => {
              if (eventData?.approvalGranted) {
                await cancelOrder();
              } else {
                Modal.error({
                  title: "Approval Required",
                  content: "The cancellation request was not approved.",
                });
              }
            });
          } else {
            await cancelOrder();
          }
        },
      });
    }
  };

  const cashManagementColumn = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: "30%",
    },
    {
      title: "Customer",
      dataIndex: "customer",
      key: "customer",
      width: "30%",
    },
    {
      title: "Reasons",
      dataIndex: "note",
      key: "note",
      width: "33%",
    },
    {
      title: "Transactions(Rs)",
      dataIndex: "amount",
      key: "amount",
      width: "20%",
      render: (text, record) => {
        return record.cashAddInFlag === true ? <span style={{ color: "red" }}>-{record.amount}</span> : record.amount;
      },
    },
  ];

  // const renderDeliveryDate = () => {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //         gap: "6px",
  //         padding: "3px 6px",
  //         border: "1px solid #ccc",
  //         borderRadius: "4px",
  //         color: "white",
  //         cursor: "pointer",
  //         width: "fit-content",
  //       }}
  //     >
  //       <CalendarOutlined
  //         style={{
  //           fontSize: "0.85rem",
  //           cursor: "pointer",
  //           paddingBottom: "0.1em",
  //         }}
  //       />
  //       <span style={{ fontSize: "0.7rem" }}>{cart?.deliveryDate || "Delivery Date"}</span>
  //     </div>
  //   );
  // };

  const discardGiftCards = async (cart) => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    if (giftCardData.length > 0) {
      let details = [];
      cart?.giftCardData?.map((ele) => {
        details.push(`{
            cardNo: ${ele.number ? `"${ele.number}"` : null}
            referenceNo: "${ele.refId}"
                }`);
      });
      discardGiftCard(null, null, details);
      let upsertDetails = [];
      giftCardData.map((ele) => {
        upsertDetails.push(`{
            cardNo: ${ele.number ? `"${ele.number}"` : null}
            type: "RD"
            referenceNo: "${cart.referenceId}"
            amount: ${ele.amount * -1}
            cardPin: ${ele?.pin ? `"${ele?.pin}"` : null}
            tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
            b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
                }`);
      });
      const data = {
        query: `
            mutation {
              upsertGiftCardTransaction(giftCardTransactions: [${upsertDetails}]) {
                status
                message
              }
            }`,
      };
      await upsertGiftCardTransaction(data);
    }
  };

  const clearCart = async (type) => {
    const tillSession = JSON.parse(localStorage.getItem("tillSession"));
    const tillSessionId = tillSession.tillSessionId;
    const newDocumentSequence = cart.parked === "Y" ? documentSequence : documentSequence + 1;
    let cartToDb = cart;
    cartToDb.orderTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    cartToDb.createdBy = tillData.tillAccess.csUserId;
    cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId;
    cartToDb.orderDate = moment(new Date()).format("DD-MM-YYYY");
    cartToDb.tillSessionId = tillSessionId;
    cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
    cartToDb.isSynced = 0;
    cartToDb.syncAttempts = 0;
    cartToDb.customerSearchKey = cart.customer.code;
    cartToDb.tax = 0;
    cartToDb.total = 0;
    cartToDb.docType = "Invoice";
    cartToDb.totalQty = 0;
    cartToDb.couponInput = [];
    cartToDb.discount = 0;
    cartToDb.isReturn = false;
    cartToDb.items.forEach((item) => {
      item.realWeight = item.weight;
      item.salePrice = 0;
      item.sunitprice = 0;
      item.netStd = 0;
      item.nettotal = 0;
      item.unitTax = 0;
      item.taxAmount = 0;
      item.weight = 0;
      item.unitPrice = 0;
      item.isReturn = false;
      item.netList = 0;
      item.discount = 0;
      item.linetax = 0;
      item.linenet = 0;
      item.linegross = 0;
      item.linestd = 0;
      item.netunit = 0;
      item.listPrice = 0;
      item.grossunit = 0;
      item.grossstd = 0;
      item.grosslist = 0;
    });
    deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
    setGiftCardData([]);
    if (type === "Layaway") {
      setDocumnetSequence(documentSequence);
    } else {
      localStorage.setItem("documentSequence", newDocumentSequence);
      setDocumnetSequence(newDocumentSequence);
      await db.orders.add(cartToDb);
    }
  };

  // const handleSelectProduct = async () => {
  //   await db.products
  //     .filter((product) => product.isactive === true)
  //     .filter((product) => product.productSegment !== "BG")
  //     .toArray()
  //     .then((productsFetched) => {
  //       const lowerCaseSearchInput = productSearchInput.toLowerCase();
  //       const filteredProducts = productsFetched.filter(
  //         (product) =>
  //           product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
  //           product?.batchIndex === lowerCaseSearchInput ||
  //           product?.upcIndex === lowerCaseSearchInput ||
  //           product?.value === lowerCaseSearchInput ||
  //           product?.upc === lowerCaseSearchInput
  //       );
  //       if (filteredProducts.length === 0) {
  //         {
  //           message.info(`${t("product_search_category_error")}`);
  //         }
  //       } else {
  //         setProductsList(filteredProducts);
  //       }
  //     });
  // };
  const handleSelectProduct = async () => {
    try {
      const normalizedValue = productSearchInput?.toString().trim();
      const lowerCaseSearchInput = normalizedValue.toLowerCase();

      let productsFetched = await db.products
        .filter((product) => product.isactive === true)
        .filter((product) => product.productSegment !== "BG")
        .toArray();

      let filteredProducts = productsFetched.filter(
        (product) =>
          product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
          product?.batchIndex === lowerCaseSearchInput ||
          product?.upcIndex === normalizedValue ||
          product?.value === normalizedValue ||
          product?.upc === normalizedValue
      );

      // 🔥 ONLY ADDITION → SYNC WHEN NOT FOUND
      if ((!filteredProducts || filteredProducts.length === 0) && normalizedValue) {
        try {
          console.log("Syncing from handleSelectProduct:", normalizedValue);

          const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

          await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, normalizedValue);

          // 🔁 Re-fetch after sync (same logic as yours)
          productsFetched = await db.products
            .filter((product) => product.isactive === true)
            .filter((product) => product.productSegment !== "BG")
            .toArray();

          filteredProducts = productsFetched.filter(
            (product) =>
              product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
              product?.batchIndex === lowerCaseSearchInput ||
              product?.upcIndex === normalizedValue ||
              product?.value === normalizedValue ||
              product?.upc === normalizedValue
          );
        } catch (err) {
          console.error("Sync failed in handleSelectProduct:", err);
        }
      }

      // ✅ FINAL RESULT (UNCHANGED BEHAVIOR)
      if (!filteredProducts || filteredProducts.length === 0) {
        message.info(`${t("product_search_category_error")}`);
      } else {
        setProductsList(filteredProducts);
      }
    } catch (error) {
      console.error("Error in handleSelectProduct:", error);
    }
  };

  useEffect(async () => {
    if (cart.items.length === 0 && cart.payments.length > 0) {
      await cart.payments.map(async (payment) => {
        handleDeletePayment(payment);
      });
    }
  }, [cart]);

  const handleDeletePayment = (payment) => {
    let paid = 0;
    Promise.all(
      cart.payments.map(async (pay) => {
        if (payment.name.toLowerCase() === "gift card" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          let setAuthTokens;
          if (authHeaders && authHeaders.access_token) {
            setAuthTokens = authHeaders.access_token;
          }
          const upsertDetails = giftCardData.map((ele) => ({
            cardNo: ele.number ? ele.number : null,
            type: "RD",
            referenceNo: cart.referenceId,
            amount: ele.amount * -1,
            cardPin: ele.pin ? ele.pin : null,
          }));

          const upsertDetailsStrings = upsertDetails.map(
            (detail) => `{
            cardNo: ${detail.cardNo ? `"${detail.cardNo}"` : null},
            type: "${detail.type}",
            referenceNo: "${detail.referenceNo}",
            amount: ${detail.amount},
            cardPin: ${detail.cardPin ? `"${detail.cardPin}"` : null}
            tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
            b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
          }`
          );

          const data = {
            query: `
                mutation {
                  upsertGiftCardTransaction(giftCardTransactions: [${upsertDetailsStrings}]) {
                    status
                    message
                  }
                }`,
          };

          const response = await upsertGiftCardTransaction(data);
          let cardDetails = [...giftCardData];
          let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
          if (response.data.data.upsertGiftCardTransaction.status == 200) {
            upsertDetails.forEach((detail) => {
              cardDetails.push({
                number: detail.cardNo,
                amount: detail.amount,
                redemptionId: uniqId,
                pin: detail.cardPin ? detail.cardPin : null,
              });
            });
          }
          setGiftCardData(cardDetails);
        } else if (payment.iscredit && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          const trxData = [
            {
              b2cCustomerId: cart?.customer?.cwrCustomerId,
              trxDate: moment(new Date()).format("YYYY-MM-DD"),
              trxAmt: Number(payment.amount) * -1,
              openingAmt: cart?.customer?.creditBalance - Number(payment.amount),
              closingAmt: cart?.customer?.creditBalance,
              type: "CR",
              cwrTillId: null,
              sOrderId: null,
              referenceNo: cart?.referenceId,
            },
          ];
          const creditUpsertResponse = await upsertCreditTransaction(trxData);
        } else if (payment.name.toLowerCase() === "loyalty" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          await handleLoyaltyPayment(payment, cart);
        } else if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        }
      })
    )
      .then((results) => {
        // Filter out undefined results (where payment name matched)
        cart.payments = results.filter((result) => result !== undefined);
        cart.paid = paid + (cart?.advancePayment || 0);
        setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
        if (payment?.name?.toLowerCase() === "cash") {
          cart.tenderedAmount = cart.tenderedAmount - payment.amount;
        }
        localStorage.setItem("cartObj", JSON.stringify(cart));
        setCart(cart);
      })
      .catch((error) => {
        // Handle errors
        console.error(error);
      });
  };

  const handleKeyvalue = async (key) => {
    if (key === "0") {
      setSelectedPaymentMethod({});
      setKeyValue("0");
      setSelectedKeys([]);
    }
    if (key === "1") {
      filterdParkedList?.map((item, index) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item.parkedCart.customer.name;
        item.qty = item.parkedCart.totalQty;
      });
      setKeyValue("1");
      setSelectedKeys([]);
    }
    if (key === "2") {
      setKeyValue("2");
      setSelectedKeys([]);
    }

    if (key === "3") {
      showOrderHistory();
      setKeyValue("3");
      setSelectedKeys([]);
    }

    if (key === "4") {
      setSyncLoad(true);
      let tillData = JSON.parse(localStorage.getItem("tillData"));
      // const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : defaultCustomer;
      const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : tillData.tillAccess.csBunit.b2cCustomer;
      setCart({ ...cart, customer: defaultCustomer });
      await processSync(tillData, setGlobalStore, "Incremental Sync");
      setSyncLoad(false);
      setGlobalStore({ percent: "0%" });
      setGlobalStore({ productCategoryPercentage: "0" });
      setGlobalStore({ productPercentage: "0" });
      setGlobalStore({ promotionPercentage: "0" });
      // window.location.reload();
    }

    if (key === "7") {
      setKeyValue("7");
      setSelectedKeys([]);
    }

    if (key === "parked-bill") {
      const parkedList = JSON.parse(localStorage.getItem("parkedList")) || [];
      const updatedParkedList = parkedList.map((item) => ({
        ...item,
        status: "Parked",
        key: uuidv4().replace(/-/g, "").toUpperCase(),
        customer: item?.parkedCart?.customer?.name.toLowerCase(),
        qty: item.parkedCart.totalQty,
      }));
      setFilterdParkedList(updatedParkedList);
      localStorage.setItem("parkedList", JSON.stringify(updatedParkedList));
    }
  };
  const showConfirm = () => {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        title: (
          <>
            <ExclamationCircleOutlined style={{ color: "#FAAD17" }} /> Confirm Payment Details
          </>
        ),
        icon: null,
        content: (
          <div
            style={{
              background: "#fff",
              height: "auto",
              width: "100%",
              border: "1px solid #fff",
              borderRadius: "7px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* Bill Amount Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Bill Amount</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(Math.abs(cart.total)).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Tendered Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Tendered</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(amount).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Received Row */}
            <Row
              style={{
                fontSize: "1em", // Adjust font size for readability
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Received</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {Math.abs(cart.total - cart.paid).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Change Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Change Due</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {cart.paid + parseFloat(amount) - Math.abs(cart.total) > 0
                    ? (cart.paid + parseFloat(amount) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                    : cart?.change <= 0
                      ? "0.00"
                      : cart?.change}
                </p>
              </Col>
            </Row>
          </div>
        ),
        onOk() {
          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
        cancelButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the Cancel button
          },
        },
        okButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the OK button
          },
        },
      });
    });
  };

  const showMoreItems = () => {
    const PaymentMethods = tillData.tillAccess.csBunit.paymentMethodList;
    let paymentDetails = getFilteredPaymentMethods();
    if (cart?.docType === "Advance") {
      paymentDetails = [
        ...paymentDetails,
        // {
        //   cWRPaymentMethodID: "",
        //   sequenceNo: 9999,
        //   finPaymentmethodId: "",
        //   finFinancialAccountId: "",
        //   finDayCloseAccountId: null,
        //   name: "Complete Order",
        //   integratedPayment: false,
        //   isloyalty: false,
        //   paymentProvider: null,
        //   iscredit: false,
        //   isGiftCard: false,
        //   isDefault: "N",
        //   csCurrencyId: "",
        //   isoCode: "AED",
        //   isactive: true,
        //   salesType: [],
        // },
      ];
    }
    const isPreOrderPage = window.location.pathname.includes("/preorder");
    const isRefundScenario = amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash";
    const maxPaymentsToShow = isRefundScenario ? 3 : 4;
    let itemsPerPage =
      tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === maxPaymentsToShow
        ? maxPaymentsToShow
        : cart.layAway === "Y"
          ? maxPaymentsToShow
          : maxPaymentsToShow;
    if (startIndex + itemsPerPage >= paymentDetails.length) {
      if (startIndex < paymentDetails.length) {
        setShowPayments(paymentDetails.slice(startIndex, paymentDetails.length));
        setStartIndex(paymentDetails.length);
      } else {
        setShowPayments(paymentDetails.slice(0, itemsPerPage));
        // setStartIndex(4);
        setStartIndex(itemsPerPage);
      }
    } else {
      setShowPayments(paymentDetails.slice(startIndex, itemsPerPage + startIndex));
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const confirmUnlink = () => {
    Modal.confirm({
      title: "Confirm Unlink",
      content: "Are you sure you want to unlink the till?",
      okText: "Yes",
      cancelText: "Cancel",
      okButtonProps: { style: { display: "inline-block" } },
      onOk: async () => {
        await tillUnlink(); // Perform the unlink operation on confirmation
      },
      onCancel: () => {
        console.log("Unlink operation cancelled");
      },
    });
  };

  const tillUnlink = async () => {
    const unlinkTillAPI = async () => {
      try {
        let id = tillData.tillAccess.cwrTill.cwrTillID; // Ensure `tillData` is defined and accessible
        const response = await unlinkTill(id);

        if (response.data.data.unlinkTill.status === "200") {
          const keepKey = ""; // Specify any keys to retain if needed
          localStorage.clear(); // Clear local storage

          // Clear IndexedDB tables
          await Promise.all(
            db.tables.map(async (table) => {
              if (table.name !== keepKey) {
                await table.clear();
              }
            })
          );
        }

        document.cookie.split(";").forEach((cookie) => {
          document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`);
        });

        localStorage.removeItem("unlink"); // Remove specific item
        window.location.assign(`${redirectUrl}sign-in`); // Redirect to SSO URL
      } catch (error) {
        console.error("Error in unlinkTillAPI:", error);
      }
    };

    await unlinkTillAPI(); // Await the internal API call
  };

  const getProductNearByStock = async () => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    try {
      const stockInputValues = {
        query: `
          query {
            getProductsNearbyStock(
              bUnitId: "${tillData.tillAccess.csBunit.csBunitId}",
              code: "${selectedProductInCart.value}"
            ) {
              csBunitId
              value
              name
              totalQty
              stores {
                csNearbyStoreId
                name
                nearbybUnitId
                viewStock
                isIssue
                warehouse {
                  mWarehouseID
                  name
                  value
                  storageBin {
                    mStoragebinID
                    name
                    stocks {
                      mStockID
                      qtyonhand
                      product {
                        mProductId
                        value
                        name
                        upc
                        uom {
                          csUomId
                          name
                        }
                        productCategory {
                          mProductCategoryId
                          value
                          name
                        }
                      }
                      batch {
                        mBatchId
                        batchno
                        upc
                        price
                        startdate
                        enddate
                        life
                        purchasePrice
                        listPrice
                        purchaseDate
                      }
                    }
                    totalQty
                  }
                }
              }
            }
          }
        `,
      };

      const response = await getProductsNearbyStockService(stockInputValues);

      const { stores, totalQty, csBunitId } = response.data.data.getProductsNearbyStock;

      const currentStock = {
        csNearbyStoreId: "53F4FBEBDAB94C4AB205B7415EBD739E",
        name: tillData.tillAccess.csBunit.mWarehouse.name,
        nearbybUnitId: "EEF9FADCE0D74AE3B8B6096E6C35B6AA",
        viewStock: "Y",
        isIssue: "Y",
        warehouse: {
          mWarehouseID: "79FD0E516E4F4C5F9A7932F0C5C82C92",
          name: tillData.tillAccess.csBunit.mWarehouse.name,
          value: "Central WH TTLLC",
          storageBin: {
            mStoragebinID: "09581CA09C154830A20B88370C501FD6",
            name: "Central Warehouse",
            stocks: [],
            totalQty: totalQty || 0,
          },
        },
      };

      const isStorePresent = stores?.some((store) => store?.nearbybUnitId === csBunitId);
      setStockList(isStorePresent ? stores : [currentStock, ...stores]);
    } catch (error) {
      console.error("Error fetching nearby stock:", error);
    }
  };

  const handleViewStockClick = () => {
    getProductNearByStock();
  };

  const onChangeInput = async (event) => {
    const inputVal = event.target.value;
    setProductSearchInput(inputVal);
    localStorage.setItem("productName", inputVal);
    keyboard?.current?.setInput(inputVal);
    if (posConfig?.product_search_display_mode === "dropdown") {
      if (inputVal.trim() === "") {
        setOptions([]);
        setProductMap({});
        return;
      }
      // await handleSearch(inputVal);
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        handleSearch(inputVal);
      }, 1000); // 🔥 smooth delay
    }
  };

  // const onChangeInput = async (event) => {
  //   const inputVal = event.target.value;
  //   // await handleSearch(inputVal);
  //   setProductSearchInput(inputVal);
  //   localStorage.setItem("productName", inputVal);
  //   keyboard?.current?.setInput(inputVal);
  // };

  // const handleSearch = async (data) => {
  //   const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  //   const search = data.toLowerCase();
  //   if (!data) {
  //     setOptions([]);
  //     return;
  //   }

  //   let products;

  //   if (posConfig?.is_smart_product_search === "Y") {
  //     products = await db.products
  //       .filter((product) => product.isactive === true)
  //       .filter((product) => product.productSegment !== "BG")
  //       .filter((product) => product.value?.toLowerCase() === data)
  //       .limit(20)
  //       .toArray();

  //     if (products.length === 0) {
  //       products = await db.products
  //         .filter((product) => product.isactive === true)
  //         .filter((product) => product.productSegment !== "BG")
  //         .filter((product) => {
  //           return product.upcIndex === data || product.upc === data || product.name?.toLowerCase().includes(search);
  //         })
  //         .limit(20)
  //         .toArray();
  //     }
  //   } else {
  //     products = await db.products
  //       .filter((product) => product.isactive === true)
  //       .filter((product) => product.productSegment !== "BG")
  //       .filter((product) => {
  //         return product.name?.toLowerCase().includes(search) || product.upcIndex === data || product.upc === data || product.value === data;
  //       })
  //       .limit(20)
  //       .toArray();
  //   }
  //   if (products.length > 0) {
  //     const filteredOptions = products.map((item) => ({
  //       label: `${item.value} - ${item.name}`,
  //       value: item.value,
  //     }));
  //     const map = {};
  //     products.forEach((item) => {
  //       map[item.value] = item;
  //     });
  //     setOptions(filteredOptions);
  //     setProductMap(map);
  //     if (products.length === 1) {
  //       const selectedProduct = products[0];
  //       // setProductSearchInput(`${selectedProduct.value} - ${selectedProduct.name}`);
  //     }
  //   } else {
  //     setOptions([]);
  //     setProductMap({});
  //   }
  // };
  const handleSearch = async (data) => {
    const posConfig = JSON.parse(localStorage.getItem("posConfig"));

    const normalizedData = data?.toString().trim();
    const search = normalizedData.toLowerCase();

    if (!normalizedData) {
      setOptions([]);
      return;
    }

    let products;

    if (posConfig?.is_smart_product_search === "Y") {
      products = await db.products
        .filter((product) => product.isactive === true)
        .filter((product) => product.productSegment !== "BG")
        .filter((product) => product.value?.toLowerCase() === search)
        .limit(20)
        .toArray();

      if (products.length === 0) {
        products = await db.products
          .filter((product) => product.isactive === true)
          .filter((product) => product.productSegment !== "BG")
          .filter((product) => {
            return product.upcIndex === normalizedData || product.upc === normalizedData || product.name?.toLowerCase().includes(search);
          })
          .limit(20)
          .toArray();
      }
    } else {
      products = await db.products
        .filter((product) => product.isactive === true)
        .filter((product) => product.productSegment !== "BG")
        .filter((product) => {
          return product.name?.toLowerCase().includes(search) || product.upcIndex === normalizedData || product.upc === normalizedData || product.value === normalizedData;
        })
        .limit(20)
        .toArray();
    }

    // 🔥 CONTROLLED SYNC (VERY IMPORTANT)
    if ((!products || products.length === 0) && normalizedData.length >= 3) {
      try {
        console.log("Autocomplete sync:", normalizedData);

        const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

        await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, normalizedData);

        // 🔁 Re-fetch after sync
        products = await db.products
          .filter((product) => product.isactive === true)
          .filter((product) => product.productSegment !== "BG")
          .filter((product) => {
            return product.name?.toLowerCase().includes(search) || product.upcIndex === normalizedData || product.upc === normalizedData || product.value === normalizedData;
          })
          .limit(20)
          .toArray();
      } catch (err) {
        console.error("Autocomplete sync failed:", err);
      }
    }

    // ✅ FINAL RESULT (UNCHANGED)
    if (products.length > 0) {
      const filteredOptions = products.map((item) => ({
        label: `${item.value} - ${item.name}`,
        value: item.value,
      }));

      const map = {};
      products.forEach((item) => {
        map[item.value] = item;
      });

      setOptions(filteredOptions);
      setProductMap(map);

      if (products.length === 1) {
        const selectedProduct = products[0];
        // setProductSearchInput(`${selectedProduct.value} - ${selectedProduct.name}`);
      }
    } else {
      setOptions([]);
      setProductMap({});
    }
  };

  // const handleDateSelect = (record) => (date, dateString) => {
  //   let updatedCart;
  //   setSelectedDate(date); // Store the selected date (you can use it elsewhere)

  //   setCalendarVisible(false); // Close the calendar after selection
  //   if (searchInputRef?.current) {
  //     searchInputRef?.current.focus();
  //   }
  //   if (record !== null && cart.items.length > 0) {
  //     updatedCart = { ...cart };
  //     let index = updatedCart.items.findIndex((res) => res.lineId === record.lineId);
  //     if (index >= 0) {
  //       updatedCart.items[index].deliveryDate = date && date.format("DD-MM-YYYY HH:mm:ss");
  //     }
  //     toggleCalendar(record.lineId);
  //   } else {
  //     updatedCart = {
  //       ...cart,
  //       deliveryDate: (date && date.format("DD-MM-YYYY HH:mm:ss")) || "",
  //       deliveryDatePromised: (date && dateString) || "", // Update the delivery date in the cart
  //     };
  //   }
  //   setSelectedProductForNotes(null);
  //   setCart(updatedCart);
  //   localStorage.setItem("cartObj", JSON.stringify(updatedCart));
  //   setIsInputFocused(false);
  //   let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
  //     ? JSON.parse(localStorage.getItem("orderTimeDetails"))
  //     : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
  //   if (updatedCart.items.length === 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === updatedCart.customer.cwrCustomerId) {
  //     orderTimeDetails = {
  //       ...orderTimeDetails,
  //       paymentStartTime: "",
  //       orderStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
  //     };
  //   } else if (updatedCart.items.length > 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== updatedCart.customer.cwrCustomerId) {
  //     orderTimeDetails = {
  //       ...orderTimeDetails,
  //       paymentStartTime: "",
  //     };
  //   }
  //   if (updatedCart.description === "") {
  //     orderTimeDetails = {
  //       ...orderTimeDetails,
  //       paymentStartTime: "",
  //       orderStartTime: "",
  //     };
  //   }
  //   localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
  // };

  // const calendarContent = (record) => (
  //   <DatePicker
  //     showTime={{ format: "hh:mm A" }}
  //     format="DD-MM-YYYY hh:mm A"
  //     onChange={handleDateSelect(record)}
  //     disabledDate={(current) => {
  //       return current && current < moment().startOf("day");
  //     }}
  //     value={selectedDate}
  //     style={{ width: 250 }}
  //   />
  // );

  // const toggleCalendar = (key) => {
  //   setCalendarVisibleMap((prev) => ({
  //     ...prev,
  //     [key]: !prev[key] || false, // Toggle or default to false
  //   }));
  // };
  const removeProductModal = (record) => {
    setShowCustomMix(false);
    deleteProduct(record);
  };

  const modulo = (a, b) => {
    return a - b * Math.floor(a / b);
  };

  let barcodeFlag = false;
  const inputElement = document.getElementById("sm-customer-search");
  const amountInput = document.getElementById("sm-amount-input");
  const totalAmountInout = document.getElementById("sm-total-amount-input");
  const inputFocused = inputElement === document.activeElement || amountInput === document.activeElement || totalAmountInout === document.activeElement;
  const approvalFlag = localStorage.getItem("approvalFlag") ? localStorage.getItem("approvalFlag") : "1";
  if (
    !couponModalVisible &&
    !displayAddNewCustomer &&
    !validateGiftCard &&
    !displayCustomerSearch &&
    !displayEditOldCustomer &&
    !giftCardFlag &&
    !filterDrawer &&
    !isGiftCardFlag &&
    !manualDiscountModalVisible &&
    !loyalityOtpModalVisible &&
    !inputFocused &&
    !showCustomMix &&
    approvalFlag === "1"
  ) {
    barcodeFlag = true;
  } else {
    barcodeFlag = false;
  }

  const cartItems = (parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
    (item) => item.weight !== 0
  );
  const hasExpandableRows = cartItems.some((item) => item.children && item.children.length > 0);

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
      <>
        <div style={{ backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%" }}>
          {showPreOrders ? (
            <ManagePreorder
              {...props}
              isLocked={isLocked}
              setIsLocked={setIsLocked}
              isSectionVisible={isSectionVisible}
              setIsSectionVisible={setIsSectionVisible}
              showPreOrders={showPreOrders}
              setShowPreOrders={setShowPreOrders}
              dateRange={dateRange}
              setDateRange={setDateRange}
              expandedRowKeys={expandedRowKeys}
              setExpandedRowKeys={setExpandedRowKeys}
              checkedKeys={checkedKeys}
              setCheckedKeys={setCheckedKeys}
              retrunSearchType={retrunSearchType}
              setReturnSearchType={setReturnSearchType}
            />
          ) : isLocked ? (
            <div
              style={{
                backgroundColor: colorVariable ? colorVariable : "#f3f4f9",
                height: "100vh",
                width: "100%",
                display: isLocked ? "block" : "none",
              }}
            >
              <Row style={{ height: "9vh", background: "", padding: "0.8% 0" }}>
                <Col span={6}>
                  <img
                    src={POSLogo}
                    style={{
                      height: "2.8vw",
                      paddingLeft: "1vw",
                      paddingTop: "1vh",
                    }}
                  />
                </Col>
                <Col
                  span={18}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                    paddingRight: "1%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "end",
                      justifyContent: "center",
                      padding: "0.5vw",
                      border: "1px solid #3C424B",
                      borderRadius: "50%",
                    }}
                  >
                    <img src={userIcon} style={{ height: "2.7vh" }} />
                  </div>
                  <span
                    style={{
                      color: "#0F0718",
                      fontSize: "1vw",
                      fontFamily: "Inter",
                      padding: "0 2%",
                      fontWeight: "600",
                      wordWrap: "break-word",
                    }}
                  >
                    Till ID : {JSON.parse(localStorage.getItem("tillValue"))?.name}
                  </span>
                  <div style={{ paddingRight: "2%" }}>
                    <img src={isOnline ? Online : Ofline} style={{ height: "3.5vh", cursor: "pointer" }} /> &nbsp;
                  </div>
                </Col>
              </Row>
              <Row style={{ paddingTop: "17vh" }}>
                <Col span={8} />
                <Col
                  span={8}
                  style={{
                    background: "#fff",
                    borderRadius: "5px",
                    height: "45vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0px 4px 4px 0px #00000033",
                  }}
                >
                  <img
                    src={LockScreen}
                    style={{
                      marginBottom: "0.2vh",
                      marginTop: "-17vh",
                      width: "25%",
                    }}
                    alt=""
                  />
                  <span style={{ fontSize: "14px", fontWeight: 400 }}>Screen Locked </span>
                  <Form layout="vertical" style={{ width: "80%" }}>
                    <Col style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                      <label style={{ fontWeight: 500, fontSize: "15px" }}>Username</label>
                      <Form.Item>
                        <Input
                          value={userData.user}
                          style={{
                            width: "100%",
                            padding: "10px",
                            fontWeight: 500,
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                      <Button
                        style={{
                          background: "#2F3856",
                          fontWeight: 500,
                          fontSize: "18px",
                          color: "#fff",
                          width: "100%",
                          height: "7vh",
                          borderRadius: "5px",
                          border: "none",
                        }}
                        onClick={handleLogin}
                      >
                        Log In
                      </Button>
                    </Col>
                  </Form>
                </Col>

                <Col span={8} />
              </Row>
            </div>
          ) : isParkedBill ? (
            <div
              style={{
                background: colorVariable ? colorVariable : "#f3f4f9",
                height: "100vh",
              }}
            >
              <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
                <Col span={6}>
                  <img
                    src={Back}
                    id="sm-parked-bill-back"
                    onClick={() => {
                      setIsparkedBill(false);
                      setIsInputFocused(false);
                      setParkedBillSearchInput("");
                      setLayoutName("default");
                    }}
                    style={{
                      height: "3vw",
                      paddingBottom: "0.7em",
                      cursor: "pointer",
                    }}
                  />
                  <span
                    style={{
                      paddingRight: "1vw",
                      fontSize: "1.8em",
                      fontWeight: 500,
                      margin: "0.5em",
                      paddingTop: "0.5em",
                      color: "#0F0718",
                    }}
                  >
                    Park Bills
                  </span>
                </Col>
                <Col
                  span={18}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  <Input
                    placeholder={`Search for customers`}
                    ref={parkedBillRef}
                    prefix={<img src={CustomerSearch} style={{ width: "1.5em" }} alt="" />}
                    allowClear={false}
                    style={{ width: "70%", borderRadius: "5px", border: "none" }}
                    onPressEnter={() => {
                      searchParkedBill(parkedBillSearchInput);
                    }}
                    onChange={(e) => {
                      onChangeParkedBill(e.target.value);
                      keyboard?.current?.setInput(e.target.value);
                    }}
                    id="sm-parked-bill-customer"
                    onFocus={() => {
                      setTimeout(() => {
                        setInputName("parkedBill");
                        setOpen(true);
                        keyboard?.current?.setInput(parkedBillSearchInput);
                      }, 300);
                    }}
                    onBlur={() => {
                      setIsInputFocused(false);
                    }}
                    value={parkedBillSearchInput}
                    className="parkedCustomer-sm"
                    width={700}
                  />
                </Col>
              </Row>
              <br />
              {/* <Row style={{ paddingBottom: "3vh" }}>
               
                  <Col span={13} style={{ display: "flex", justifyContent: "end" }}>
                  <span style={{ position: "absolute", bottom: 0, paddingRight: "1vw", color: "#A4CD38", fontSize: "1.1vw" }}>
                    <img src={DownloadIcon} style={{ height: "1.3vw", paddingRight: "4px" }} />
                    Export list
                  </span>
                  </Col>
                  </Row> */}
              <Row style={{ padding: "0 1em" }}>
                <Table
                  style={{
                    width: "100%",
                    overflowY: "auto",
                    border: "none",
                    fontSize: "1vw",
                    borderRadius: "10px",
                    padding: "0 1em",
                    height: "83vh",
                    background: themeJSON.productTableBGColor || "#fff",
                    //   boxShadow: "0 0 2px rgba(0, 0, 0, 0.2)",
                  }}
                  pagination={false}
                  columns={columns}
                  dataSource={filterdParkedList}
                  // scroll={{ y: "53vh" }}
                  rowClassName={(record) => (selectedKeys[0] === record.key ? "tableSelectedBlue" : "tableNonSelectedWhite")}
                  className="sm-cart-table"
                  expandable={{
                    expandedRowKeys,
                    onExpand: handleExpandPerkedData,
                    expandedRowRender: (record) => (
                      <div
                        style={{
                          padding: "1% 4% 1% 4%",
                          backgroundColor: "#f3f4f9",
                        }}
                      >
                        <Row>
                          <Col span={21}>
                            <Row>
                              <Col span={12} className="td-nested-title-sm">
                                Description
                              </Col>
                              <Col span={3} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                                Qty
                              </Col>
                              <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                                Unit Price
                              </Col>
                              <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "right" }}>
                                Net Total
                              </Col>
                            </Row>
                            <Row style={{ paddingBottom: "0.5vw", fontSize: "1vw" }}>
                              {record.parkedCart.items.map((e) => {
                                return (
                                  <>
                                    {/* <Col span={12} className="td-nested-description-sm"> */}
                                    <Col span={12} className="td-nested-title-sm" style={{ fontSize: "1.2em" }}>
                                      {e.name}
                                    </Col>
                                    <Col
                                      span={3}
                                      style={{
                                        textAlign: "center",
                                        fontWeight: "400",
                                        fontSize: "1.2em",
                                      }}
                                    >
                                      {e.weight}
                                    </Col>
                                    <Col span={1} style={{ textAlign: "center" }} />
                                    <Col
                                      span={3}
                                      style={{
                                        textAlign: "right",
                                        fontWeight: "400",
                                        paddingRight: "1vw",
                                        fontSize: "1.2em",
                                      }}
                                    >
                                      {e.realPrice}
                                    </Col>
                                    <Col span={1} style={{ textAlign: "right" }} />
                                    <Col
                                      span={3}
                                      style={{
                                        textAlign: "right",
                                        marginLeft: "6vw",
                                        fontWeight: "400",
                                        fontSize: "1.2em",
                                      }}
                                    >
                                      {e.nettotal.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)}
                                    </Col>
                                  </>
                                );
                              })}
                            </Row>
                            <p
                              style={{
                                width: "96%",
                                marginLeft: "0%",
                                borderTop: "1.3px solid rgba(52, 40, 44, 0.55)",
                                marginBottom: "0px",
                              }}
                            />
                            <Row style={{ paddingTop: "5px" }}>
                              <Col span={3} offset={17} className="td-subtotal">
                                <span className="td-subTotalText">Subtotal</span>
                                <span className="td-subTotalText">Total tax</span>
                              </Col>
                              <Col span={3} className="td-subtotal" style={{ textAlign: "right" }}>
                                <span className="td-subTotalText">{(record.parkedCart.total - record.parkedCart.tax).toFixed(pricePrecision)}</span>
                                <span className="td-subTotalText">{record.parkedCart.tax.toFixed(pricePrecision)}</span>
                              </Col>
                            </Row>
                            <Row style={{ marginBottom: "1%" }}>
                              <Col span={3} offset={17} className="td-subtotal" style={{ padding: "4px 0" }}>
                                <span className="td-total">SALE TOTAL</span>
                              </Col>
                              <Col
                                span={3}
                                className="td-subtotal"
                                style={{
                                  borderBottom: "1px solid rgba(52, 40, 44, 0.55)",
                                  textAlign: "right",
                                  paddingTop: "4px",
                                }}
                              >
                                <span className="td-total">{record.parkedCart.total}</span>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={3} className="td-bottons">
                            <p
                              style={{
                                cursor: "pointer",
                                padding: "5.5% 12%",
                                borderRadius: "3px",
                                border: "1px solid #fff",
                                background: "#fff",
                                fontSize: "1em",
                              }}
                              onClick={() => {
                                setTableValue("POS");
                                setIsparkedBill(false);
                                retrieveParkedData(record);
                                upsertPOSLog(cart, "OPK", "Retrieved");
                              }}
                              id="sm-parked-bill-retrieve"
                            >
                              <img
                                src={Retrieve}
                                style={{
                                  height: "1vw",
                                  paddingRight: "0.4vw",
                                  cursor: "pointer",
                                }}
                              />
                              Retrieve sale
                            </p>
                            <p
                              style={{
                                cursor: "pointer",
                                padding: "5.5% 13%",
                                borderRadius: "3px",
                                border: "1px solid #fff",
                                background: "#fff",
                                fontSize: "1em",
                              }}
                              onClick={() => {
                                setParkedBill(record);
                                discardMessage("Discard Sale", "Are you sure you want to discard the sale!", record);
                              }}
                              id="sm-parked-bill-discard"
                            >
                              <img src={Cancel} style={{ height: "1.1vw", paddingRight: "0.4vw" }} />
                              Discard sale
                            </p>
                          </Col>
                        </Row>
                      </div>
                    ),
                    expandIcon: ({ expanded, onExpand, record }) => (
                      <span id="sm-parked-bill-expand" onClick={(e) => onExpand(record, e)}>
                        {expanded ? <DownOutlined style={{ color: "#929098" }} /> : <RightOutlined style={{ color: "#929098" }} />}
                      </span>
                    ),
                  }}
                  onRow={(record) => ({
                    onClick: () => handleExpandPerkedData(record), // Handle row click to expand
                  })}
                  onExpand={handleExpandPerkedData}
                />
              </Row>
            </div>
          ) : isCashMangement ? (
            <div
              style={{
                background: colorVariable ? colorVariable : "#f3f4f9",
                height: "100vh",
                fontSize: "1vw",
              }}
            >
              <Row style={{ padding: "1.5em 1.5em 0 1.5em" }}>
                <Col span={6}>
                  <img
                    src={Back}
                    id="sm-cash-management-back"
                    onClick={() => {
                      setIsCashManagement(false);
                    }}
                    style={{
                      height: "3.1vw",
                      paddingBottom: "0.7em",
                      cursor: "pointer",
                    }}
                  />
                  <span
                    style={{
                      paddingRight: "1vw",
                      color: "#0F0718",
                      fontSize: "1.8em",
                      fontWeight: 500,
                      marginLeft: "0.5em",
                    }}
                  >
                    {/* <img src={DownloadIcon} style={{ height: "1.3vw", paddingRight: "4px" }} /> */}
                    Cash Management
                  </span>
                </Col>
                <Col
                  span={18}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    style={{
                      width: "10.3vw",
                      height: "5.5vh",
                      // border: "1px solid #0F0718",
                      borderRadius: "4px",
                      fontWeight: "500",
                      marginRight: "1.4vw",
                      fontSize: "1em",
                      color: "#fff",
                      background: "#2F3856",
                    }}
                    id="sm-cash-management-remove"
                    onClick={() => {
                      setAddCashFlag(true);
                      setCashAddInFlag(true);
                    }}
                  >
                    Remove Cash
                  </Button>
                  <Button
                    id="sm-cash-management-add"
                    style={{
                      width: "10.3vw",
                      height: "5.5vh",
                      borderRadius: "4px",
                      fontWeight: "500",
                      fontSize: "1em",
                      color: "#fff",
                      background: "#2F3856",
                    }}
                    onClick={() => {
                      setAddCashFlag(true);
                      setCashAddInFlag(false);
                    }}
                  >
                    Add Cash
                  </Button>
                </Col>
              </Row>
              <br />
              <Row style={{ padding: "0 1.5em" }}>
                <Table
                  style={{
                    width: "100%",
                    overflowY: "auto",
                    border: "none",
                    fontSize: "1.5vw",
                    borderRadius: "10px",
                    padding: "0 1em",
                    height: "83vh",
                    background: themeJSON.productTableBGColor || "#fff",
                    // boxShadow: "0 0 2px rgba(0, 0, 0, 0.2)",
                  }}
                  pagination={false}
                  columns={cashManagementColumn}
                  className="sm-cashmanagement-table"
                  // className="sm-cart-table"
                  dataSource={cashManagementData}
                />
              </Row>
              <RetailModals {...props} selectBagRef={selectBagRef} />
            </div>
          ) : syncLoad ? (
            <>
              <LoadingScreen
                colorVariable={colorVariable}
                POSLogo={POSLogo}
                formattedDateTime={formattedDateTime}
                clock1={clock1}
                leftLoading={leftLoading}
                percent={percent}
                productCategoryPercentage={productCategoryPercentage}
                productPercentage={productPercentage}
                promotionPercentage={promotionPercentage}
              />
            </>
          ) : (
            <>
              <Row
                style={{
                  padding: "0.8% 0",
                  height: "9vh",
                  alignItems: "center",
                  fontSize: "1vw",
                }}
              >
                <Col
                  onClick={() => {
                    setTillLink(true);
                  }}
                  style={{ cursor: "pointer" }}
                  span={1}
                >
                  <img src={sideMenu} style={{ paddingLeft: "1rem", height: "2vw" }} />
                </Col>
                <Col
                  span={5}
                  onDoubleClick={() => {
                    deleteReceipt(true);

                    const isPreOrder = posConfig?.enablePreOrder === "Y";
                    const isEstimate = posConfig?.enableEstimate === "Y";

                    history.push(isPreOrder && isEstimate ? "/estimate" : "/pos");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img src={themeJSON.logoURL || POSLogo} style={{ height: "2.5vw", paddingLeft: "0.4vw" }} />
                </Col>
                <Col
                  span={2}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {showSaleType === true ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#0F0718",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "13px",
                        paddingLeft: "1vw",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (cart.docType !== "Advance") {
                          setIsSaleTypeFlag(true);
                        }
                      }}
                    >
                      {selectedSaleType}
                    </span>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={1} />
                <Col
                  span={5}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "1em",
                      color: themeJSON.dateTimeTextColor || "#929098",
                      marginLeft: "7vw",
                    }}
                  >
                    {" "}
                    {formattedDateTime}
                  </span>
                </Col>
                <Col
                  span={2}
                  style={{
                    textAlign: "center",
                    color: themeJSON.orderNoTextColor || "#0F0718",
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1.1em",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {posConfig?.enableProductGrouping === "Y" && (
                    <CodeSandboxOutlined
                      style={{ fontSize: "18px", cursor: "pointer" }}
                      onClick={() => {
                        setShowCustomMix(true);
                        localStorage.setItem("customMix", "CM");
                        // localStorage.setItem("productSegment", "CB");
                      }}
                    />
                  )}
                </Col>
                <Col
                  span={4}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    paddingleft: "2vw",
                  }}
                ></Col>
                <Col
                  span={5}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                    // paddingRight: "1%",
                  }}
                >
                  <img
                    onClick={() => {
                      if (isOnline) {
                        setIsLocked(true);
                      } else {
                        errorMessage("Sync Failed", "Please check your network connection and try again");
                      }
                    }}
                    src={LockIcon}
                    style={{ height: "3vh", cursor: "pointer", marginRight: "0.7rem" }}
                  />

                  <div
                    style={{
                      display: "flex",
                      alignItems: "end",
                      justifyContent: "center",
                      padding: "0.5vw",
                      border: "1px solid #3C424B",
                      borderRadius: "50%",
                    }}
                  >
                    <img src={userIcon} style={{ height: "2.7vh" }} />
                  </div>
                  <div
                    style={{
                      marginLeft: "1vw",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span
                      style={{
                        color: themeJSON.orderNoTextColor || "#0F0718",
                        fontSize: "1em",
                        fontFamily: "Inter",
                        fontWeight: "500",
                        wordWrap: "break-word",
                      }}
                    >
                      {userData.user}
                    </span>
                    <span
                      style={{
                        color: themeJSON.orderNoTextColor || "#0F0718",
                        fontSize: "0.8em",
                        fontFamily: "Inter",
                        fontWeight: "500",
                        wordWrap: "break-word",
                      }}
                    >
                      Till ID : {JSON.parse(localStorage.getItem("tillValue"))?.name}
                    </span>
                  </div>
                  <div style={{ marginLeft: "3%" }}>
                    <img
                      src={Online}
                      style={{
                        display: !isOnline && "none",
                        height: "2.5vh",
                        cursor: "pointer",
                        paddingBottom: "0.5vh",
                      }}
                    />{" "}
                    <img
                      src={Ofline}
                      style={{
                        display: isOnline && "none",
                        height: "2.5vh",
                        cursor: "pointer",
                        paddingBottom: "0.5vh",
                      }}
                    />{" "}
                  </div>
                </Col>
              </Row>
              {barcodeFlag && <BarCodeComponentForRetail onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />}
              <div style={{ display: "flex", height: "91vh" }}>
                {/* Left side UI */}
                <div style={{ width: "63.9%" }}>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      padding: "0 0 0 1.7%",
                    }}
                  >
                    <div style={{ width: "93%" }}>
                      <RenderInput
                        posConfig={posConfig}
                        options={options}
                        productMap={productMap}
                        pickProduct={pickProduct}
                        productSearchInput={productSearchInput}
                        setProductSearchInput={setProductSearchInput}
                        setOptions={setOptions}
                        keyboard={keyboard}
                        filterDrawer={filterDrawer}
                        searchInputRef={searchInputRef}
                        clearProductSearchResults={clearProductSearchResults}
                        onChangeInput={onChangeInput}
                        setOpen={setOpen}
                        setInputName={setInputName}
                        setIsInputFocused={setIsInputFocused}
                        onBarcodeInput={onBarcodeInput}
                        productSearchInputRef={productSearchInputRef}
                        debounceRef={debounceRef}
                        enterRef={enterRef}
                      />
                    </div>
                    <Button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "4.5%",
                        margin: "0 0.2vw 0 0.8vw",
                        borderRadius: "7px",
                        height: "inherit",
                        borderColor: "#fff",
                      }}
                      onClick={() => setIsProductsFilter(true)}
                    >
                      <img src={ScanIcon} style={{ height: "2.7vh" }} />
                    </Button>
                    <Button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "4.5%",
                        margin: "0 1vw 0 0.5vw",
                        borderRadius: "7px",
                        height: "inherit",
                        borderColor: "#fff",
                      }}
                      id="sm-product-drawer"
                      // onClick={() => setIsProductsFilter(true)}
                      onClick={() => {
                        setFilterDrawer(true);
                      }}
                    >
                      <img src={FilterIcon} style={{ height: "2.7vh" }} />
                    </Button>
                  </div>
                  <div style={{ padding: "1.5%" }}>
                    {cart.layAway === "Y" && posConfig?.advanceLayaway === "Y" ? (
                      <div
                        style={{
                          position: "absolute",
                          bottom: "29vh",
                          left: "56vw",
                        }}
                      >
                        <span style={{ opacity: "0.5" }}>ADVANCE</span>
                      </div>
                    ) : null}
                    <div
                      style={{
                        position: "absolute",
                        top: "57%",
                        left: "30%",
                        transform: "translate(-50%, -50%)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "", // Adjusted for larger text
                        height: "54px", // Adjusted for 54px font
                        zIndex: 10, // Ensure it appears above table
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Montserrat",
                          fontWeight: "bold",
                          fontSize: "50px",
                          color: "#000",
                          textAlign: "center",
                          opacity: "10%",
                        }}
                      >
                        PRE-ORDER
                      </span>
                    </div>
                    <div
                      style={{
                        height: "6vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        textAlign: "center",
                        backgroundColor: "#7A92AC",
                        padding: "1vw 0.5rem",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        color: "#fff",
                      }}
                    >
                      <span
                        style={{ fontSize: "0.85rem", cursor: "pointer" }}
                        // onClick={() => {
                        //   // setIsSectionVisible(true);
                        //   let filtredDocument = documentTypes?.filter((element) => element.type !== selectedDocumentType && element.isVisible);
                        //   if (cart?.docType !== "Advance" && filtredDocument.length > 0) {
                        //     setShowDocumentPopup(true);
                        //   }
                        // }}
                      >
                        Pre-Order
                        {/* {selectedDocumentType || "Sales Invoice"} <DownOutlined style={{ fontSize: "0.7rem" }} /> */}
                      </span>
                      <span style={{ fontSize: "0.7rem", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {posConfig?.disableOfflineBilling !== "Y" && <>Pre-Order No: {cart.documentno}</>}
                      {posConfig?.enableOrderLevelNarration === "Y" && (
                        <img
                          src={NotesAdd}
                          onClick={() => {
                            setNotesPopup(true);
                            if (cart.description && cart.description.trim() !== "") {
                              setNotesValue(cart.description);
                            }
                            setIsInputFocused(true);
                          }}
                          style={{ height: "0.85rem", paddingLeft: "0.4rem", cursor: "pointer", paddingRight: "0.5rem" }}
                        />
                      )}
                        {posConfig?.enableDeliveryDate === "Y" && (
                          <Popover
                            content={calendarContent(null)}
                            trigger="click"
                            visible={calendarVisible}
                            onVisibleChange={(visible) => {
                              setCalendarVisible(visible);
                            }}
                          >
                            {/* <CalendarOutlined
                              style={{
                                fontSize: "0.85rem",
                                paddingLeft: "0.7rem",
                                cursor: "pointer",
                              }}
                            /> */}
                            {renderDeliveryDate()}
                          </Popover>
                        )}
                      </span>
                    </div>
                    <Table
                      className="sm-cart-table-pos"
                      style={{
                        width: "100%",
                        overflowY: "auto",
                        border: "none",
                        // fontSize: "1vw",
                        borderRadius: "7px",
                        padding: "0px 7px",
                        // border: "1px solid rgba(146, 144, 152, 0.4)",
                        height: "50.5vh",
                        background: themeJSON.productTableBGColor || "#fff",
                      }}
                      pagination={false}
                      dataSource={
                        // Filter the data where weight is greater than 0
                        (parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
                          (item) => item.weight !== 0
                        )
                      }
                      sticky
                      id="sm-cart-table"
                      rowKey="lineId"
                      rowClassName={(record) => (selectedProductInCart.lineId === record.lineId ? "tableRowSelectedBlue" : "tableRowNonSelectedWhite")}
                      columns={[
                        {
                          title: "Item Name",
                          dataIndex: "name",
                          key: "name",
                          width: "28%",
                          render: (text, record, index) => {
                            return (
                              <>
                                <div className="offerName" style={{ display: "flex", alignItems: "center" }}>
                                  {posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? (
                                    <>
                                      {record.salesRepName ? (
                                        <>
                                          <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                                          <span>{record.salesRepName}</span>
                                        </>
                                      ) : (
                                        cart.salesRepName && (
                                          <>
                                            <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                                            <span>{cart.salesRepName}</span>
                                          </>
                                        )
                                      )}
                                    </>
                                  ) : null}
                                </div>

                                <div
                                  onClick={() => {
                                    if (cart.type !== "Layaway") {
                                      selectProductInCart(record);
                                      selectedRowKeys.length > 0 && selectedProductInCart.productId === record.productId ? setShowPaymentMethods(false) : "";
                                    }
                                  }}
                                  id="sm-product-name"
                                  className="tableRow"
                                  style={{
                                    textAlign: "left",
                                    // paddingLeft: record.groupedItems ? "40px" : "0px",
                                    // paddingleft: record.children && record.children.length > 0 ? "40px" : "0px",
                                    marginLeft: 0,
                                  }}
                                >
                                  {record.name}
                                </div>

                                <div
                                  className="offerName"
                                  style={
                                    {
                                      // paddingLeft: record.children?.[0]?.groupedItems ? "40px" : "0px",
                                    }
                                  }
                                >
                                  <p style={{ margin: 0 }}>{record.cardNo ? record.cardNo : record.value}</p>
                                  {/* {record?.customText ? <p style={{ margin: 0, padding: 0, color: "#FFA500" }}>{record?.customText}</p> : ""} */}
                                  {record.newCustomAttributes &&
                                    record.newCustomAttributes.length > 0 &&
                                    Object.entries(record.newCustomAttributes[0]).map(([key, value]) => {
                                      return (
                                        value && (
                                          <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>
                                            {key} - {value}
                                          </p>
                                        )
                                      );
                                    })}

                                  {record.selectedAddons &&
                                    record.selectedAddons.length > 0 &&
                                    record.selectedAddons.map((item) => {
                                      return item?.name && <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>{item.name}</p>;
                                    })}
                                  {record.batchedProduct === "Y" && record.batchedForSale === "Y" && record.batchno && (
                                    <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>Batch: {record.batchno}</p>
                                  )}
                                  {(record?.uomData?.[0]?.name || record?.uom_name) && (
                                    <p style={{ margin: 0, padding: 0, paddingBottom: "0.4vh", color: "#8c92ac", fontStyle: "italic" }}>
                                      {record?.uomData?.[0]?.name || record?.uom_name}
                                    </p>
                                  )}

                                  <span
                                    style={{
                                      background: Math.abs(record.discount) > 0 ? "#F8C519" : "",
                                      padding: "0.25vw",
                                      display: record.discountName ? "" : "none",
                                    }}
                                  >
                                    {Math.abs(record.discount) > 0 ? (
                                      record.discountName ? (
                                        <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} />
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      ""
                                    )}{" "}
                                    {Math.abs(record.discount) > 0 ? record.discountName || "" : ""}{" "}
                                  </span>
                                </div>
                              </>
                            );
                          },
                        },
                        {
                          title: "Qty",
                          dataIndex: "weight",
                          key: "weight",
                          width: "11%",
                          render: (text, record, index) => {
                            const wt = parseFloat(text);
                            if (Number.isInteger(wt)) {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {/* <div style={{ margin: "0 3px", fontWeight: "500", fontSize: "1.1vw" }}>{wt.toFixed(record.isQtyDesimal)}</div> */}
                                  <div className="tableRow">{wt.toFixed(record.isQtyDesimal)}</div>
                                </div>
                              );
                            } else {
                              return (
                                <>
                                  <div>{parseFloat(text).toFixed(record.isQtyDesimal)}</div>
                                  <div className="offerName">
                                    {record.salesRepName && posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? record.salesRepName : ""}
                                  </div>
                                </>
                              );
                            }
                          },
                          align: "center",
                        },
                        {
                          title: "Discount",
                          dataIndex: "discount",
                          key: "discount",
                          width: "11%",
                          render: (text, record) => {
                            return (
                              <div>
                                <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
                              </div>
                            );
                          },
                          align: "center",
                        },
                        {
                          title: "Tax",
                          dataIndex: "taxAmount",
                          key: "taxAmount",
                          width: "11%",
                          render: (text, record) => {
                            return (
                              <div>
                                <span className="tableRow">
                                  {text?.toFixed(pricePrecision).length < 8 ? parseFloat(text)?.toFixed(pricePrecision) : `${text?.toString().substring(0, 8)}`}
                                </span>
                              </div>
                            );
                          },
                          align: "center",
                        },
                        {
                          title: "Price",
                          dataIndex: "realPrice",
                          key: "realPrice",
                          width: "10%",
                          render: (text, record) => {
                            return (
                              <div>
                                <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
                              </div>
                            );
                          },
                          align: "center",
                        },
                        {
                          title: "Total",
                          dataIndex: "nettotal",
                          key: "nettotal",
                          width: "15%",
                          render: (text, record) => {
                            return (
                              <div style={{ position: "relative" }}>
                                <span className="tableRow" style={{ width: "12%", left: "0" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                  &nbsp;
                                  {
                                    // text.toString().length < 9 ?
                                    parseFloat(text).toFixed(pricePrecision)
                                    // :
                                    // `${text.toString().substring(0, 5)}...`
                                  }
                                  &nbsp;
                                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                </span>
                              </div>
                            );
                          },
                          align: "center",
                        },
                        {
                          title: "",
                          dataIndex: "",
                          key: "",
                          width: "10%",
                          render: (text, record) => {
                            if (record.groupedItems === true) return null;
                            return (
                              <div style={{ position: "relative", display: "flex", justifyContent: "space-evenly" }}>
                                <img
                                  src={DeleteProduct}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    clearSelectedProductInCart();
                                    removeProductModal(record);
                                    setIsInputFocused(false);
                                    setShowInputFields(false);
                                    setCustomMixItems([]);
                                    setGroupQty(1);
                                    setActiveInput("search");
                                    if (searchInputRef?.current) {
                                      searchInputRef?.current.focus();
                                    }
                                  }}
                                  id="sm-product-delete"
                                  style={{
                                    height: "2.5vh",
                                    cursor: "pointer",
                                    right: 1,
                                    top: "15%",
                                  }}
                                  // style={{ height: "18px", width: "18px", cursor: "pointer", right: 1, top: "15%", paddingRight: "3px" }}
                                />
                                {posConfig?.enableLineLevelNarration === "Y" && (
                                <img
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    clearSelectedProductInCart();
                                    setNotesPopup(true);
                                    setIsInputFocused(true);
                                    setNotesValue(record.notes);
                                    setSelectedProductForNotes(record);
                                    // console.log("notesValue--------=======>.>",selectedProductForNotes)
                                    selectProductInCart(record);
                                    setIsInputFocused(false);
                                  }}
                                  src={NotesImage}
                                  alt=""
                                  style={{
                                    height: "14px",
                                    width: "14px",
                                    cursor: "pointer",
                                    paddingleft: "0.8vw",
                                  }}
                                />
                                )}
                                {posConfig?.showLineSalesRep === "Y" && (
                                  <img
                                    // src={userIcon}
                                    src={userAddIcon}
                                    style={{ height: "2.3vh", cursor: "pointer", paddingTop: "1px" }}
                                    alt=""
                                    onClick={() => {
                                      setOpenSalesRep({ flag: true, level: "line" });
                                    }}
                                  />
                                )}
                              </div>
                            );
                          },
                          align: "center",
                        },
                      ]}
                      {...(hasExpandableRows && {
                        expandable: {
                          expandedRowRender: (record) => (record.children && record.children.length > 0 ? <div></div> : null),
                          rowExpandable: (record) => record.children && record.children.length > 0,
                        },
                      })}
                      onRow={(record) => ({
                        onClick: () => {
                          qtyInputRef?.current?.focus();
                          // if (cart.type !== "Layaway") {
                          if (record.posPriceEdit === "Y") {
                            qtyInputRef?.current?.focus();
                            setShowInputFields(true);
                            setRealPrice(record.weight);
                            setFirstInputValue(true);
                          } else {
                            setShowInputFields(false);
                          }
                          if (record.children && record.children.length > 0) {
                            setSelectedCustomMix(record);
                            setCustomMixItems(record.children);
                            setGroupQty(record.weight);
                            setExistingGroupItems(true);
                          }
                          setIsInputFocused(false);
                          setOverPayedAmount(0);
                          setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
                          selectProductInCart(record);
                          setQtyNumberFlag(0);
                          setShowPaymentMethods(false);
                          setSelectedProductInCart(record);
                          setStockList([]);
                        },
                      })}
                    />
                  </div>
                  <div style={{ padding: "0 1.5% 0 1.5%", display: "flex" }}>
                    <div
                      style={{
                        background: themeJSON.taxAndDiscountSectionBGColor || "#fff",
                        height: "23.5vh",
                        width: "60%",
                        marginRight: "1%",
                        border: "1px solid #fff",
                        borderRadius: "7px",
                        padding: "0.5vh",
                        fontSize: "1vw",
                        position: "relative",
                      }}
                    >
                      <Row style={{ height: "4.5vh" }}>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "0.8vw",
                            textAlign: "left",
                            fontWeight: "500",
                            color: "#0F0718",
                          }}
                        >
                          <p style={styles.screenStyles.mainScreen.subTotalText}>Subtotal:</p>
                        </Col>
                        {/* <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "0.8vw", textAlign: "right", justifyContent: "end", color: "#0F0718" }}> */}
                        <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                          &nbsp;
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                            }}
                          >
                            {parseFloat(localStorage.getItem("cartObj") ? cart.subTotal : cart.subTotal).toFixed(pricePrecision)}
                          </p>
                          <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                        </Col>
                      </Row>

                      <Row style={{ height: "4.4vh" }}>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "0.8vw",
                            fontWeight: "500",
                            textAlign: "left",
                          }}
                        >
                          <p style={styles.screenStyles.mainScreen.subTotalText}>Discount:</p>
                        </Col>
                        <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                          &nbsp;
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                            }}
                          >
                            {parseFloat(cart.discount ? cart.discount : 0).toFixed(pricePrecision)}
                          </p>
                          <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                        </Col>
                      </Row>

                      <Row style={{ height: "4.5vh" }}>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "0.8vw",
                            fontWeight: "500",
                            textAlign: "left",
                          }}
                        >
                          <p style={styles.screenStyles.mainScreen.subTotalText}>Tax:</p>
                        </Col>
                        <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                          &nbsp;
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                            }}
                          >
                            {parseFloat(cart.tax).toFixed(pricePrecision)}
                          </p>
                          <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                        </Col>
                      </Row>
                      <Row style={{ height: "4.5vh" }}>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "0.8vw",
                            fontWeight: "500",
                            textAlign: "left",
                          }}
                        >
                          <p style={styles.screenStyles.mainScreen.subTotalText}>Net Value:</p>
                        </Col>
                        <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                          &nbsp;
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                            }}
                          >
                            {parseFloat(localStorage.getItem("cartObj") ? cart.total : cart.total)?.toFixed(pricePrecision)}
                          </p>
                          <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                        </Col>
                      </Row>

                      <Row style={{ height: "4.5vh" }}>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "0.8vw",
                            fontWeight: "500",
                            textAlign: "left",
                          }}
                        >
                          <p style={styles.screenStyles.mainScreen.subTotalText}>Total Items / Total Qty:</p>
                        </Col>
                        <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                            }}
                          >
                            {cart.items.length} / {parseFloat(cart.totalQty).toFixed(2)}
                          </p>
                        </Col>
                      </Row>
                      {/* </Scrollbars> */}
                    </div>
                    <div style={{ height: "23.7vh", width: "40%", fontSize: "1vw" }}>
                      <div
                        id="sm-cart-total"
                        // onClick={handleCartTotalClick}
                        // onClick={verifyStock}
                        onClick={() => {
                          const newDocType = "Advance";
                          const updatedCart = {
                            ...cart,
                            layAway: "Y",
                            docType: "Invoice",
                            refundAmount: amount < 0 ? amount : 0,
                          };
                          setCart(updatedCart);
                          localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                          verifyStock(newDocType);
                        }}
                        style={{
                          height: "18.2vh",
                          position: "relative",
                          background: themeJSON.totalAmountToPaySectionBGColor || "#2F3856",
                          borderRadius: "7px",
                          cursor: "pointer",
                        }}
                      >
                        <p
                          style={{
                            padding: "0.7vw 0 0 1vw",
                            color: "#fff",
                            fontSize: "1em",
                            fontWeight: "500",
                            height: "4.5vh",
                          }}
                        >
                          Total Amount To Pay
                        </p>
                        {cart.total !== undefined ? (
                          <p
                            style={{
                              textAlign: "center",
                              color: "#fff",
                              fontSize: "2.5em",
                              fontWeight: "500",
                              height: "14.4vh",
                              width: "100%",
                            }}
                          >
                            {" "}
                            {parseFloat(localStorage.getItem("cartObj") ? cart.total : cart.total)?.toFixed(pricePrecision)}
                          </p>
                        ) : (
                          <p
                            style={{
                              textAlign: "center",
                              color: "#fff",
                              fontSize: "2.5em",
                              fontWeight: "500",
                              height: "14.4vh",
                              width: "100%",
                            }}
                          >
                            {" "}
                            0.00
                          </p>
                        )}
                      </div>
                      <Row gutter={[8, 0]} style={{ marginTop: "0.8vh" }}>
                        <Col span={12} onClick={openDisplayParkedBillModal}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "500",
                              textAlign: "left",
                              border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                              height: "4.8vh",
                              borderRadius: "5px",
                              cursor: "pointer",
                              backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                            }}
                          >
                            <img src={Hold} style={{ height: "2.5vh" }} />
                            <span
                              style={{
                                margin: "0",
                                textAlign: "center",
                                color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                                paddingLeft: "0.5vw",
                                fontSize: "1em",
                                fontWeight: 500,
                              }}
                            >
                              Hold
                            </span>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",

                              fontWeight: "500",
                              justifyContent: "center",
                              border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                              height: "4.8vh",
                              borderRadius: "5px",
                              cursor: "pointer",
                              backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                            }}
                            id="sm-delete-cart"
                            onClick={deleteProductModal}
                          >
                            <img src={Cancel} style={{ height: "2.5vh" }} />
                            <span
                              style={{
                                textAlign: "center",
                                margin: "0",
                                color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                                paddingLeft: "0.5vw",
                                fontSize: "1em",
                                fontWeight: 500,
                              }}
                            >
                              Cancel
                            </span>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    width: "35.6%",
                    padding: "0% 0% 0 0.4%",
                    borderRadius: "10px",
                    paddingBottom: "0",
                    height: "89vh",
                    marginRight: "1%",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId ||
                    tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId ? (
                      <Input
                        className="productSearch-sm"
                        id="sm-customer-search"
                        style={{
                          borderRadius: "0.5vw",
                          height: "4.9vh",
                          borderColor: "#fff",
                        }}
                        placeholder="Enter customer number/name"
                        prefix={<img src={CustomerSearch} alt="" style={{ height: "2.7vh" }} />}
                        onClick={() => {
                          if (cart.isReturn !== true) {
                            setDisplayCustomerSearch(true);
                            setCloseCustomerFlag(true);
                          }
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          padding: "0.7vh 1.3vh",
                          border: "none",
                          background: "#fff",
                          borderRadius: "4px",
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          height: "5vh",
                          alignItems: "center",
                        }}
                      >
                        <span>
                          <img src={CustomerIcon} style={{ height: "3.5vh" }}></img>{" "}
                          <span style={{ fontSize: "1vw" }}>
                            {cart?.customer?.name} - {cart?.customer?.b2cCustomerSegment?.name}
                          </span>
                        </span>
                        <span>
                          <img
                            src={View}
                            style={{
                              height: "3vh",
                              paddingBottom: "0.1em",
                              cursor: "pointer",
                            }}
                            id="sm-customer-view"
                            onClick={() => {
                              if (cart.isReturn !== true) showEditOldCustomerFields(cart?.customer);
                            }}
                          />{" "}
                          &#124;{" "}
                          <EditOutlined
                            style={{ cursor: "pointer" }}
                            id="sm-customer-edit"
                            onClick={() => {
                              if (cart.isReturn !== true) {
                                showEditOldCustomerFields(cart?.customer);
                                setEditFlag(true);
                              }
                            }}
                          />{" "}
                          &#124;{" "}
                          <CloseOutlined
                            style={{ fontSize: "2vh" }}
                            onClick={() => {
                              if (cart.isReturn !== true) {
                                removeCutomer();
                              }
                            }}
                          ></CloseOutlined>
                        </span>
                      </div>
                    )}
                    <img
                      src={AddUser}
                      style={{
                        height: "1.6vw",
                        paddingLeft: "1vw",
                        cursor: "pointer",
                        display: cart?.customer?.cwrCustomerId === customerId ? "" : "none",
                      }}
                      onClick={() => {
                        if (cart.isReturn !== true) showAddNewCustomerFields(cart.customer);
                      }}
                    />
                  </div>
                  <div style={{ display: "flex", fontSize: "1vw" }}>
                    <div
                      style={{
                        width: "18%",
                        paddingTop: "3%",
                        display: "flex",
                        flexDirection: "column-reverse",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          marginBottom: "0.01rem",
                          display: tillAccessData?.productSync === "Y" ? "block" : "none",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          id="sm-product-sync"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                          onClick={() => {
                            let parkedBills = JSON.parse(localStorage.getItem("parkedList"));
                            if (cart.items.length > 0) {
                              openDisplayParkedBillModal();
                            } else if (parkedBills?.length > 0) {
                              message.error(`${messages.errors.sync.clear_parked_bills}`);
                            } else {
                              if (isOnline) {
                                handleKeyvalue("4");
                              } else {
                                errorMessage("Sync Failed", "Please check your network connection and try again");
                              }
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                              fontSize: "1vw",
                            }}
                          >
                            <img src={SyncIcon} style={{ height: "2.5vh" }} color={"#fff"} />
                            <span style={styles.screenStyles.mainScreen.posIcon}>Product Sync</span>
                          </div>
                        </button>
                      </div>
                      <div style={{ width: "100%", display: "none" }}>
                        <button
                          className="cartMenuItems"
                          id="sm-pos"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                          // onClick={() => {
                          //   handleKeyvalue("0");
                          //   setTableValue("POS");
                          // }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <POSIcon color={"#fff"} />
                            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                              Point of Sale
                            </span>
                          </div>
                        </button>
                      </div>

                      <div
                        style={{
                          width: "100%",
                          marginBottom: "0.37rem",
                          display: "none",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <img src={information} style={{ height: "2.7vh" }} color={"#fff"} />
                            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                              Information
                            </span>
                          </div>
                        </button>
                      </div>

                      <div style={{ width: "100%", marginBottom: "0.37rem", display: tillAccessData?.manualDiscount === "Y" ? "block" : "none" }}>
                        <button
                          className="cartMenuItems"
                          id="sm-discount"
                          style={{ backgroundColor: "#2F3856", border: "1px solid #2F3856", borderRadius: "7px", height: "9.5vh" }}
                          onClick={async () => {
                            if (selectedProductInCart) {
                              const pr = await db.pricingRules.toArray();
                              const index = pr.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId && md.manualDiscount === "Y");
                              if (index !== -1) {
                                const pricingRule = pr[index];
                                if (pricingRule.type !== "TD") {
                                  let discountValue =
                                    pricingRule.discountType === "V"
                                      ? selectedProductInCart.discount
                                      : ((selectedProductInCart.discount / (selectedProductInCart?.realPrice * selectedProductInCart?.weight)) * 100).toFixed(pricePrecision);
                                  manualDiscountForm.setFieldsValue({ discountName: pricingRule.mPricingrulesId, discountValue: discountValue });
                                  setManualDiscountInput(discountValue);
                                  setSelectedManualDiscountTypeValue(pricingRule);
                                } else {
                                  const matchedPricingRule = cart?.manualDiscountData?.totalLevelDiscount?.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
                                  manualDiscountForm.setFieldsValue({
                                    discountName: pricingRule.mPricingrulesId,
                                    discountValue: cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue,
                                  });
                                  setManualDiscountInput(cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue);
                                  setSelectedManualDiscountTypeValue(pricingRule);
                                }
                              } else {
                                manualDiscountForm.resetFields();
                                setManualDiscountInput("");
                                setSelectedManualDiscountTypeValue("");
                              }
                            }
                            // parseInt(cart.total) > 0 && setManualDiscountModalVisible(true);
                            cart.items.length > 0 && setManualDiscountModalVisible(true);
                            setProductSearchInput("");
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                            <img src={discount} style={{ height: "2.6vh" }} color={"#fff"} />
                            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                              Manual Discount
                            </span>
                          </div>
                        </button>
                      </div>

                      <div
                        style={{
                          width: "100%",
                          marginBottom: "0.37rem",
                          display: "none",
                          fontSize: "1vw",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          id="sm-return"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                          onClick={() => {
                            if (cart.items.length > 0) {
                              openDisplayParkedBillModal();
                            } else {
                              handleKeyvalue("3");
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <img src={ReturnIcon} style={{ height: "2.5vh" }} color={"#fff"} />
                            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                              Return
                            </span>
                          </div>
                        </button>
                      </div>
                      {/* <div
                        style={{
                          width: "100%",
                          marginBottom: "0.37rem",
                          display: tillAccessData?.cashManagement === "Y" ? "block" : "none",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          id="sm-cash-management"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                          onClick={() => {
                            if (isOnline) {
                              if (cart.items.length > 0) {
                                openDisplayParkedBillModal();
                              } else {
                                handleKeyvalue("2");
                                setIsCashManagement(true);
                              }
                            } else {
                              errorMessage("Sync Failed", "Please check your network connection and try again");
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <CashManagementIcon color={"#fff"} />
                            <span style={styles.screenStyles.mainScreen.posIcon}>Cash Management</span>
                          </div>
                        </button>
                      </div> */}
                      {/* <div
                        style={{
                          width: "100%",
                          marginBottom: "0.37rem",
                          display: tillAccessData?.giftCard === "Y" ? "block" : "none",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          id="sm-sales-history"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                          onClick={() => {
                            setGiftCardType("Gift Card");
                            setIsGiftCardFlag(true);
                            setProductSearchInput("");
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <SalesHistoryIcon color={"#fff"} />
                            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                            <span style={styles.screenStyles.mainScreen.posIcon}>Gift Card</span>
                          </div>
                        </button>
                      </div> */}
                      <div
                        style={{
                          width: "100%",
                          marginBottom: "0.37rem",
                          display: posConfig?.showBags === "Y" ? "block" : "none",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          id="sm-discount"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                          onClick={() => {
                            setAddToBagFlag(true);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <img src={giftVoucher} style={{ height: "2.6vh" }} color={"#fff"} />
                            <span style={styles.screenStyles.mainScreen.posIcon}>Bag</span>
                          </div>
                        </button>
                      </div>

                      <div
                        style={{
                          width: "100%",
                          marginBottom: "0.37rem",
                          display: posConfig?.showOrderSalesRep === "Y" ? "block" : "none",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          id="sm-parked-bill"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                          onClick={() => {
                            setOpenSalesRep({ flag: true, level: "order" });
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <img src={user_add} style={{ color: "#fff", height: "2.5vh" }} />
                            <span style={styles.screenStyles.mainScreen.posIcon}>Sales Representative</span>
                          </div>
                        </button>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          marginBottom: "0.37rem",
                          display: tillAccessData?.parkedBills === "Y" ? "block" : "none",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          id="sm-parked-bill"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                          onClick={() => {
                            handleKeyvalue("parked-bill");
                            setIsparkedBill(true);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <ParkedBillIcon color={"#fff"} />
                            <span style={styles.screenStyles.mainScreen.posIcon}>Parked Bills</span>
                          </div>
                        </button>
                      </div>

                      <div
                        style={{
                          width: "100%",
                          marginBottom: "0.37rem",
                        }}
                      >
                        <button
                          className="cartMenuItems"
                          id="sm-sales-history"
                          style={{
                            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                            borderRadius: "7px",
                            height: "9.5vh",
                          }}
                          onClick={() => {
                            if (cart.items.length > 0) {
                              clearReturnCartData();
                            } else {
                              if (isOnline) {
                                let dateValue = [moment(new Date()), moment(new Date())];
                                searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true);
                                setShowPreOrders(true);
                              } else {
                                errorMessage("Sync Failed", "Please check your network connection and try again");
                              }
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <SalesHistoryIcon color={"#fff"} />
                            <span style={styles.screenStyles.mainScreen.posIcon}>Manage Pre-Orders</span>
                          </div>
                        </button>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "81.5%",
                        paddingTop: "3%",
                        display: showPaymentMethods && "none",
                      }}
                    >
                      <div
                        style={{
                          background: "#fff",
                          height: "41vh",
                          width: "95%",
                          margin: "0% 1% 2.7% 3.5%",
                          border: "1px solid #fff",
                          borderRadius: "7px",
                          visibility: Object.keys(selectedProductInCart).length > 0 ? "visible" : "hidden",
                        }}
                      >
                        {stockList.length > 0 ? (
                          <div>
                            <img
                              src={Back}
                              onClick={() => setStockList([])}
                              id="sm-parked-bill-back"
                              style={{
                                height: "2vw",
                                paddingBottom: "0.5em",
                                cursor: "pointer",
                                marginLeft: "10px",
                                marginTop: "0.7em",
                              }}
                            />
                            <Table
                              style={{
                                width: "100%",
                                overflowY: "auto",
                                borderRadius: "10px",
                                padding: "0",
                                height: "36vh",
                                background: "#fff",
                                maxHeight: "34vh",
                                display: "block",
                              }}
                              size="small"
                              locale={{ emptyText: "No data" }}
                              pagination={false}
                              dataSource={[...stockList]}
                              className="sm-stock-table"
                              columns={[
                                {
                                  title: "Store",
                                  dataIndex: "store",
                                  key: "store",
                                  render: (text, record) => <div>{record?.warehouse?.name || ""}</div>,
                                },
                                {
                                  title: "In Stock",
                                  dataIndex: "stock",
                                  key: "stock",
                                  render: (text, record) => <div>{record?.warehouse?.storageBin?.totalQty || 0}</div>,
                                  align: "right",
                                },
                              ]}
                            />
                          </div>
                        ) : (selectedProductInCart?.productSegment === "CB" && Array.isArray(selectedProductInCart?.childItems) && selectedProductInCart?.childItems?.length > 0) ||
                          (selectedProductInCart?.productSegment === "" && Array.isArray(selectedProductInCart?.addons) && selectedProductInCart?.addons?.length > 0) ? (
                          <div style={{ position: "relative", padding: "0.5rem", borderRadius: "6px", backgroundColor: "#fff", height: "100%" }}>
                            {/* Title at the top */}
                            {/* Header Row */}
                            <Row
                              style={{
                                padding: "0.1rem 0.75rem",
                                fontSize: "0.75rem",
                                fontWeight: 600,
                                color: "#2F3856",
                                borderBottom: "1px solid #e8e8e8",
                                marginBottom: "0.5rem",
                              }}
                            >
                              <Col span={8}>Name</Col>
                              <Col span={6} style={{ textAlign: "right" }}>
                                Unit Price
                              </Col>
                              <Col span={4} style={{ textAlign: "right" }}>
                                Qty
                              </Col>
                              <Col span={6} style={{ textAlign: "right" }}>
                                Total Price
                              </Col>
                            </Row>

                            {/* Item Details */}
                            <Scrollbars style={{ height: "28vh" }}>
                              {/* Child Items */}
                              {(selectedProductInCart.childItems || []).map((item) => {
                                const unitPrice = parseFloat(item.sunitprice) || 0;
                                const quantity = parseFloat(item.weight * selectedProductInCart.weight) || 0;
                                const totalPrice = unitPrice * quantity;

                                return (
                                  <Row
                                    key={item.id || item.name}
                                    style={{
                                      padding: "0 0.75rem",
                                      width: "100%",
                                      marginBottom: "0.4rem",
                                      height: "auto",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Col span={8}>
                                      <p
                                        title={item.name}
                                        style={{
                                          margin: 0,
                                          fontSize: "0.65rem",
                                          fontWeight: 500,
                                          color: "#333",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: "100%",
                                        }}
                                      >
                                        {item.name}
                                      </p>
                                    </Col>
                                    <Col span={6} style={{ textAlign: "right" }}>
                                      <p
                                        style={{
                                          margin: 0,
                                          fontSize: "0.6rem",
                                          color: "#2F3856",
                                        }}
                                      >
                                        {unitPrice.toLocaleString("en-IN")}
                                      </p>
                                    </Col>
                                    <Col span={4} style={{ textAlign: "right" }}>
                                      <p
                                        style={{
                                          margin: 0,
                                          fontSize: "0.6rem",
                                          color: "#2F3856",
                                        }}
                                      >
                                        {quantity}
                                      </p>
                                    </Col>
                                    <Col span={6} style={{ textAlign: "right" }}>
                                      <p
                                        style={{
                                          margin: 0,
                                          fontSize: "0.6rem",
                                          color: "#2F3856",
                                        }}
                                      >
                                        {totalPrice.toLocaleString("en-IN")}
                                      </p>
                                    </Col>
                                  </Row>
                                );
                              })}

                              {/* Addons */}
                              {(selectedProductInCart.addons || []).map((addon) => {
                                const unitPrice = parseFloat(addon.price) || 0;
                                const quantity = parseFloat(addon.qty) || 0;
                                const totalPrice = unitPrice * quantity;

                                return (
                                  <Row
                                    key={addon.addonProductId || addon.name}
                                    style={{
                                      padding: "0 0.75rem",
                                      width: "100%",
                                      marginBottom: "0.4rem",
                                      height: "auto",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Col span={8}>
                                      <p
                                        title={addon.name}
                                        style={{
                                          margin: 0,
                                          fontSize: "0.65rem",
                                          fontWeight: 500,
                                          color: "#333",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: "100%",
                                        }}
                                      >
                                        {addon.name}
                                      </p>
                                    </Col>
                                    <Col span={6} style={{ textAlign: "right" }}>
                                      <p
                                        style={{
                                          margin: 0,
                                          fontSize: "0.6rem",
                                          color: "#2F3856",
                                        }}
                                      >
                                        {unitPrice.toLocaleString("en-IN")}
                                      </p>
                                    </Col>
                                    <Col span={4} style={{ textAlign: "right" }}>
                                      <p
                                        style={{
                                          margin: 0,
                                          fontSize: "0.6rem",
                                          color: "#2F3856",
                                        }}
                                      >
                                        {quantity}
                                      </p>
                                    </Col>
                                    <Col span={6} style={{ textAlign: "right" }}>
                                      <p
                                        style={{
                                          margin: 0,
                                          fontSize: "0.6rem",
                                          color: "#2F3856",
                                        }}
                                      >
                                        {totalPrice.toLocaleString("en-IN")}
                                      </p>
                                    </Col>
                                  </Row>
                                );
                              })}
                            </Scrollbars>

                            {/* Modify button at bottom right */}
                            <Button
                              style={{
                                position: "absolute",
                                bottom: "0.5rem",
                                right: "0.5rem",
                                backgroundColor: "#2F3856",
                                color: "#fff",
                                width: "7vw",
                                height: "4.5vh",
                                borderRadius: "3px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "none",
                                fontSize: "0.75rem",
                              }}
                              onClick={modifyProductList}
                            >
                              Modify
                            </Button>
                          </div>
                        ) : (
                          <Row gutter={[16]} style={{ paddingTop: "3vh" }}>
                            <Col span={7} style={{ height: "24vh" }}>
                              <img
                                style={{
                                  width: "100%",
                                  height: "27vh",
                                  objectFit: "contain",
                                  borderRadius: "5px",
                                  paddingTop: "1vh",
                                  alignSelf: "center",
                                  padding: "1vh 0 1vh 0.8vw",
                                }}
                                src={selectedProductInCart.imageurl || DefaultProductImage}
                                alt=""
                              />
                            </Col>
                            <Col span={17} style={{ height: "24vh", position: "relative" }}>
                              <p
                                style={{
                                  margin: 0,
                                  fontWeight: "500",
                                  color: "#0F0718",
                                  fontSize: "1em",
                                  fontFamily: "Inter",
                                }}
                              >
                                {selectedProductInCart["name"]?.toString().substring(0, 27)}...
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontWeight: "500",
                                  color: "#0F0718",
                                  fontSize: "1em",
                                  fontFamily: "Inter",
                                }}
                              >
                                {selectedProductInCart["productBrandName"]}
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontWeight: "500",
                                  color: "#0F0718",
                                  fontSize: "2.5em",
                                  fontFamily: "Inter",
                                }}
                              >
                                {currenciesList[0].symbolRightSide === "N"
                                  ? `${currenciesList[0].currSymbol}`
                                  : currenciesList[0].symbolRightSide === "Y"
                                    ? `${currenciesList[0].currSymbol}`
                                    : ""}{" "}
                                {Number(selectedProductInCart["realPrice"]).toFixed(pricePrecision)}
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontWeight: "500",
                                  color: "#0F0718",
                                  fontSize: "1em",
                                  fontFamily: "Inter",
                                }}
                              >
                                Quantity : {selectedProductInCart["weight"]}
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontWeight: "500",
                                  color: "#0F0718",
                                  fontSize: "1em",
                                  fontFamily: "Inter",
                                }}
                              >
                                Uom : {selectedProductInCart?.uomData?.[0]?.name}
                              </p>
                              {stockList.length > 0 ? (
                                <CloseCircleOutlined
                                  onClick={() => setStockList([])}
                                  style={{
                                    position: "absolute",
                                    top: "25vh",
                                    left: "18vw",
                                    cursor: "pointer",
                                  }}
                                />
                              ) : null}
                              {selectedProductInCart?.notes && selectedProductInCart?.notes.trim() !== "" && (
                                <p
                                  style={{
                                    margin: 0,
                                    fontWeight: "400",
                                    color: "#0F0718",
                                    fontSize: "0.95em",
                                    fontFamily: "Inter",
                                    marginTop: "0.5vh",
                                  }}
                                >
                                  Notes : {selectedProductInCart.notes}
                                </p>
                              )}
                              {posConfig?.showViewStockInCartSection === "Y" && (
                                <button
                                  onClick={handleViewStockClick}
                                  style={{
                                    backgroundColor: "#046307C2",
                                    border: "1px solid #fff",
                                    borderRadius: "7px",
                                    height: "5vh",
                                    width: "7vw",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexDirection: "row",
                                      color: "#fff",
                                      fontSize: "1em",
                                      fontWeight: 500,
                                      fontFamily: "Inter",
                                    }}
                                  >
                                    View Stock
                                  </div>
                                </button>
                              )}
                              {stockList.map((record) => (
                                <p
                                  key={record.id || record.name}
                                  style={{
                                    margin: 0,
                                    fontWeight: "500",
                                    fontSize: "1em",
                                    color: "#0F0718",
                                    fontFamily: "Inter",
                                  }}
                                >
                                  {record?.name || ""} stock : {record?.warehouse?.storageBin?.totalQty || 0}
                                </p>
                              ))}
                            </Col>
                          </Row>
                        )}
                        {stockList.length < 0 ? (
                          <div style={{ padding: "1vh 1vw" }}>
                            <p
                              style={{
                                margin: 0,
                                textAlign: "left",
                                color: "#0F0718",
                                fontWeight: "500",
                              }}
                            >
                              Description:
                            </p>
                            <p
                              style={{
                                margin: 0,
                                textAlign: "left",
                                color: "#2F3856",
                                fontSize: "1em",
                                fontWeight: "500",
                              }}
                            >
                              {selectedProductInCart["description"]?.substring(0, 180)?.concat("....")}
                            </p>
                          </div>
                        ) : null}
                      </div>
                      <></>
                      {!showInputFields ? (
                        <div>
                          <Row style={{ margin: " 2% 0 0 0 " }}>
                            <Input
                              className="productSearch sm-payment-search totalQtyInput"
                              style={{
                                borderRadius: "0.5vw",
                                height: "8.3vh",
                                margin: "0 1% 2.7% 3.5%",
                                borderRadius: "5px",
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: "2.5em",
                                borderColor: "#fff",
                                color: "#2F3856",
                                fontFamily: "Inter",
                              }}
                              ref={qtyInputRef}
                              // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
                              value={selectedProductInCart.weight}
                              id="sm-amount-input"
                              // type="number"
                              onChange={(e) => {
                                if (cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0) {
                                  onChangeTotalQuantity(e.target.value?.replace(/[^\d.]/g, ""));
                                }
                              }}
                              readOnly={cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0 ? false : true}
                              placeholder="Enter Quantity"
                              onFocus={() => {
                                setIsInputFocused(true);
                              }}
                              onBlur={() => {
                                setIsInputFocused(false);
                              }}
                              // ref={quantityInputRef}
                              onPressEnter={enterTotalQty}
                            />
                          </Row>
                          <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                            <Col span={6}>
                              <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
                                1
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
                                2
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
                                3
                              </button>
                            </Col>
                            <Col span={6}>
                              <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleTotalQty("x")}>
                                <img src={CancelArrow} alt="back space" width={25} height={15} />
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
                                4
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
                                5
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
                                6
                              </button>
                            </Col>
                            <Col span={6}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <button
                                  id="sm-amount-addQuantity"
                                  onClick={() => {
                                    if (Object.keys(selectedProductInCart).length > 0) {
                                      decreaseProductQty(selectedProductInCart);
                                    }
                                  }}
                                  className="amt-dial-btn-market-qty"
                                >
                                  -
                                </button>
                                <button
                                  id="sm-amount-addQuantity"
                                  onClick={async () => {
                                    if (Object.keys(selectedProductInCart).length > 0) {
                                      increaseProductQty(selectedProductInCart);
                                    }
                                  }}
                                  className="amt-dial-btn-market-qty"
                                >
                                  +
                                </button>
                              </div>
                            </Col>
                            <Col span={18}>
                              <Row gutter={[8, 6]}>
                                <Col span={8}>
                                  <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                                    7
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                                    8
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                                    9
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                                    0
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                                    .
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                                    Clear
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
                                Enter
                              </button>
                            </Col>
                          </Row>
                        </div>
                      ) : (
                        <div>
                          <Tabs
                            defaultActiveKey="1"
                            className="custom-tabs"
                            // style={{ padding: "0 1% 0 3.5%" }}
                            onChange={(key) => {
                              if (key === "2") {
                                setTimeout(() => {
                                  realPriceRef?.current?.focus();
                                }, 10);
                              } else if (key === "1") {
                                setTimeout(() => {
                                  qtyInputRef?.current?.focus();
                                }, 10);
                              }
                            }}
                            style={{
                              // position: "absolute",
                              // top: "52%",
                              // left: "71.2%",
                              marginTop: "-11%",
                              marginLeft: "4%",
                              width: "94%",
                              height: "auto",
                              // background: "rgba(255, 255, 255, 0.95)",
                              zIndex: 1000,
                              transition: "top 0.5s ease",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-end",
                            }}
                          >
                            <TabPane tab="Qty" key="1" className="custom-tabpane" style={{ marginRight: "1vw" }}>
                              <Row style={{ margin: "0 0 0 0 " }}>
                                <Input
                                  className="productSearch sm-payment-search totalQtyInput"
                                  value={selectedProductInCart.weight}
                                  ref={qtyInputRef}
                                  style={{
                                    borderRadius: "0.5vw",
                                    height: "6.5vh",
                                    margin: "0% 1% 1% 0%",
                                    borderRadius: "5px",
                                    textAlign: "right",
                                    fontWeight: "500",
                                    fontSize: "2.5em",
                                    color: "#2F3856",
                                    borderColor: "#fff",
                                  }}
                                  id="sm-amount-input"
                                  placeholder="Enter Quantity"
                                />
                              </Row>
                              <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
                                <Col span={6}>
                                  <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
                                    1
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
                                    2
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
                                    3
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleTotalQty("x")}>
                                    <img src={CancelArrow} alt="back space" width={25} height={15} />
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
                                    4
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
                                    5
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
                                    6
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <button
                                      id="sm-amount-addQuantity"
                                      onClick={() => {
                                        if (Object.keys(selectedProductInCart).length > 0) {
                                          decreaseProductQty(selectedProductInCart);
                                        }
                                      }}
                                      className="amt-dial-btn-market-qty"
                                    >
                                      -
                                    </button>
                                    <button
                                      id="sm-amount-addQuantity"
                                      onClick={async () => {
                                        if (Object.keys(selectedProductInCart).length > 0) {
                                          increaseProductQty(selectedProductInCart);
                                        }
                                      }}
                                      className="amt-dial-btn-market-qty"
                                    >
                                      +
                                    </button>
                                  </div>
                                </Col>
                                <Col span={18}>
                                  <Row gutter={[8, 6]}>
                                    <Col span={8}>
                                      <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                                        7
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                                        8
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                                        9
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                                        0
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                                        .
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                                        Clear
                                      </button>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
                                    Enter
                                  </button>
                                </Col>
                              </Row>
                            </TabPane>
                            <TabPane tab="Price" key="2" className="custom-tabpane" style={{ marginRight: "1vw" }}>
                              <Row style={{ margin: "0 0 0 0 " }}>
                                <Input
                                  className="productSearch sm-payment-search totalQtyInput"
                                  // value={selectedProductInCart.realPrice}
                                  ref={realPriceRef}
                                  value={realPrice}
                                  onChange={(e) => {
                                    setRealPrice(e.target.value);
                                  }}
                                  style={{
                                    borderRadius: "0.5vw",
                                    height: "6.5vh",
                                    margin: "0% 1% 1% 0%",
                                    borderRadius: "5px",
                                    textAlign: "right",
                                    fontWeight: "500",
                                    fontSize: "2.5em",
                                    color: "#2F3856",
                                    borderColor: "#fff",
                                  }}
                                  id="sm-amount-input"
                                  placeholder="Enter Price"
                                />
                              </Row>
                              <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
                                <Col span={6}>
                                  <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleRealPrice("1")}>
                                    1
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleRealPrice("2")}>
                                    2
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleRealPrice("3")}>
                                    3
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleRealPrice("x")}>
                                    <img src={CancelArrow} alt="back space" style={{ width: "20px", height: "15px" }} />
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleRealPrice("4")}>
                                    4
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleRealPrice("5")}>
                                    5
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleRealPrice("6")}>
                                    6
                                  </button>
                                </Col>
                                <Col span={6}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <button
                                      id="sm-amount-addQuantity"
                                      className="amt-dial-btn-market-qty"
                                      onClick={() => {
                                        setRealPrice((prev) => {
                                          const numeric = parseFloat(prev) || 0;
                                          const newValue = Math.max(numeric - 1, 1);
                                          return newValue.toString();
                                        });
                                      }}
                                    >
                                      -
                                    </button>
                                    <button
                                      id="sm-amount-addQuantity"
                                      className="amt-dial-btn-market-qty"
                                      onClick={() => {
                                        setRealPrice((prev) => {
                                          const numeric = parseFloat(prev) || 0;
                                          return (numeric + 1).toString();
                                        });
                                      }}
                                    >
                                      +
                                    </button>
                                  </div>
                                </Col>
                                <Col span={18}>
                                  <Row gutter={[8, 6]}>
                                    <Col span={8}>
                                      <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleRealPrice("7")}>
                                        7
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleRealPrice("8")}>
                                        8
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("9")}>
                                        9
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("0")}>
                                        0
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleRealPrice("00")}>
                                        00
                                      </button>
                                    </Col>
                                    <Col span={8}>
                                      <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleRealPrice(".")}>
                                        .
                                      </button>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col span={6}>
                                  <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterRealPrice}>
                                    Enter
                                  </button>
                                </Col>
                              </Row>
                            </TabPane>
                          </Tabs>
                        </div>
                      )}
                    </div>

                    <div
                      style={{
                        width: "81.5%",
                        paddingTop: "3%",
                        display: !showPaymentMethods && "none",
                      }}
                    >
                      <Row style={{ padding: "0 1% 0 3.5%", height: "18.5vh" }} gutter={5}>
                        {_.sortBy(showPayments, "sequenceNo").map((pm, ind) => {
                          if (
                            (posConfig?.loyaltyApplicable === "N" && pm.name === "Loyalty") ||
                            (!cart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId && pm.name === "Loyalty") ||
                            (!cart.customer.iscredit && pm.iscredit) ||
                            pm.name.toLowerCase() === "cafe tips"
                          ) {
                            return null;
                          }
                          return (
                            <Col span={8} key={pm.finPaymentmethodId}>
                              <button
                                disabled={amount < 0 && pm.name.toLowerCase() !== "cash"}
                                onClick={async () => {
                                  if (amount < 0 && pm.name.toLowerCase() !== "cash") return;
                                  if (cart.items.length > 0 && pm.name !== "Complete Order") {
                                    setNumb(0);
                                    let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || {
                                      orderStartTime: "",
                                      orderEndTime: "",
                                      paymentStartTime: "",
                                    };
                                    if (orderTimeDetails.paymentStartTime === "") {
                                      orderTimeDetails = {
                                        ...orderTimeDetails,
                                        paymentStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
                                      };
                                      localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
                                    }
                                    if (pm.isWallet === "Y") {
                                      walletFunc();
                                    }
                                    if (pm.name.toLowerCase() === "card" && !pm.integratedPayment && posConfig?.enablePaymentData === "Y") {
                                      setIsCardPaymentFlag(true);
                                    }
                                    const currenciesList = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                                    const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

                                    // let originalAmount = Math.abs(cart.total) - cart.paid ?? 0;
                                    let originalAmount = Math.abs(cart.total) - (cart.paid ?? 0);

                                    // Get the smallest denomination (assuming sorted list)
                                    const smallestDenomination = currenciesList.length > 0 ? currenciesList[0].value : 1;

                                    // Round the amount to the nearest multiple of the smallest denomination
                                    let roundedAmount = Math.ceil(originalAmount / smallestDenomination) * smallestDenomination;

                                    // Calculate overpayment
                                    let overpayment = (roundedAmount - originalAmount).toFixed(precision);
                                    setOverPayedAmount(pm.roundOffForPos === "Y" && pm.integratedPayment === false ? overpayment : 0);
                                    setAmount(
                                      pm.roundOffForPos === "Y" && pm.integratedPayment === false ? roundedAmount.toFixed(precision) : parseFloat(originalAmount).toFixed(precision)
                                    );
                                    setSelectedPaymentMethod(pm);
                                    paymentModalInputRef?.current?.focus();
                                    setTimeout(() => {
                                      paymentModalInputRef?.current?.select();
                                    }, 50);
                                  }
                                  //  else if (pm.name === "Complete Order" && cart.paid >= cart.total) {
                                  //   processOrder();
                                  // }
                                  setShowInputFields(false);
                                }}
                                id={`sm-payment-${pm.name.toLowerCase()}`}
                                ref={ind === 0 ? paymentCardRef : null}
                                style={{
                                  backgroundColor: pm.name === "Complete Order" ? "#2F3856" : themeJSON.paymentMethodsBGColor || "#046307C2",
                                  border: `1px solid ${themeJSON.paymentMethodsBGColor || "#fff"}`,
                                  borderRadius: "7px",
                                  height: "8.6vh",
                                  width: "100%",
                                  cursor: "pointer",
                                }}
                                tabIndex={0}
                                onKeyPress={(e) => (e.charCode === 13 ? setSelectedPaymentMethod(pm) : null)}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "row",
                                    position: "relative",
                                    fontSize: "1vw",
                                  }}
                                >
                                  {pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId || (amount < 0 && pm.name.toLowerCase() === "cash") ? (
                                    <img
                                      src={ticSelect}
                                      style={{
                                        top: "-2vh",
                                        right: "0",
                                        height: "2.1vh",
                                        position: "absolute",
                                      }}
                                    />
                                  ) : null}
                                  <span className="payment" style={{ color: "#fff", fontSize: "1em" }}>
                                    {pm.name.toLowerCase() === "cash" ? (
                                      <>
                                        {currenciesList[0] ? currenciesList[0].currSymbol : ""}
                                        &nbsp;{pm.name}
                                      </>
                                    ) : pm.name.toLowerCase() === "card" ? (
                                      <>
                                        <img src={cardType} style={{ height: "2.5vh" }} color={"#fff"} />
                                        &nbsp;{pm.name}
                                      </>
                                    ) : pm.name.toLowerCase() === "upi" ? (
                                      <>
                                        <img src={UPI} style={{ height: "2.5vh" }} color={"#fff"} />
                                        &nbsp;{pm.name}
                                      </>
                                    ) : pm.iscredit ? (
                                      <>
                                        <img src={Credit} style={{ height: "2.5vh" }} color={"#fff"} />
                                        &nbsp;{pm.name}
                                      </>
                                    ) : pm.name.toLowerCase() === "loyalty" ? (
                                      <>
                                        <img
                                          src={Loyality}
                                          style={{
                                            height: "2.5vh",
                                            left: "0.5em",
                                          }}
                                          color={"#fff"}
                                        />
                                        &nbsp;{pm.name}
                                      </>
                                    ) : pm.name.toLowerCase() === "gift card" ? (
                                      <>
                                        <img
                                          src={Gift}
                                          style={{
                                            height: "2.5vh",
                                            marginBottom: "0.2em",
                                          }}
                                          color={"#fff"}
                                        />
                                        &nbsp;{pm.name}
                                      </>
                                    ) : pm.name.toLowerCase() === "voucher" ? (
                                      <>
                                        <img
                                          src={giftVoucher}
                                          style={{
                                            height: "2.5vh",
                                            marginBottom: "0.2em",
                                          }}
                                          color={"#fff"}
                                        />
                                        &nbsp;{pm.name}
                                      </>
                                    ) : pm.name.toLowerCase() === "credit note" ? (
                                      <>
                                        <img src={creditNote} style={{ height: "2.5vh" }} color={"#fff"} />
                                        &nbsp;{pm.name}
                                      </>
                                    ) : pm.isWallet === "Y" ? (
                                      <>
                                        <img
                                          src={walletWhite}
                                          style={{
                                            height: "2.5vh",
                                            marginBottom: "0.2em",
                                          }}
                                          color={"#fff"}
                                        />
                                        &nbsp;{pm.name}
                                      </>
                                    ) : (
                                      <>{pm.name}</>
                                    )}
                                  </span>
                                </div>
                              </button>
                            </Col>
                          );
                        })}

                        {amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash" ? (
                          <Col
                            span={8}
                            onClick={() => {
                              // if (cart.paid <= cart.total) {
                              cart.statusType = "layAway";
                              localStorage.setItem("cartObj", JSON.stringify(cart));
                              const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                              const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);

                              const isCashPayment = selectedPaymentMethod?.name?.toLowerCase() === "cash";
                              const isValidCashAmount = parseFloat(amount) % 0.25 === 0;

                              if (cart?.advancePayment > 0 && parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                                if (result !== 0 && isCashPayment) {
                                  message.warning(`${t("cash_payment_error")}`);
                                } else {
                                  processOrder("layaway");
                                }
                              } else {
                                processOrder("layaway");
                              }
                              // }
                            }}
                          >
                            <button
                              style={{
                                backgroundColor: "#2F3856",
                                border: "1px solid #fff",
                                borderRadius: "7px",
                                height: "8.6vh",
                                width: "100%",
                                cursor: "pointer",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "row",
                                  color: "#fff",
                                }}
                              >
                                Refund
                              </div>
                            </button>
                          </Col>
                        ) : null}

                        {posConfig?.advanceLayaway === "Y" ? (
                          <Col
                            span={8}
                            onClick={() => {
                              if (posConfig?.requirePaymentForAdvance === "Y" && cart.paid <= 0) {
                                message.warning(`${messages.warnings.payment.payment_required}`);
                                return;
                              }
                              if (cart.paid <= cart.total) {
                                cart.statusType = "layAway";
                                localStorage.setItem("cartObj", JSON.stringify(cart));
                                const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                                const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);

                                const isCashPayment = selectedPaymentMethod?.name?.toLowerCase() === "cash";
                                const isValidCashAmount = parseFloat(amount) % 0.25 === 0;

                                if (cart?.advancePayment > 0 && parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                                  if (result !== 0 && isCashPayment) {
                                    message.warning(`${t("cash_payment_error")}`);
                                  } else {
                                    processOrder("layaway");
                                  }
                                } else {
                                  processOrder("layaway");
                                }
                              }
                            }}
                          >
                            <button
                              style={{
                                backgroundColor: "#2F3856",
                                border: "1px solid #fff",
                                borderRadius: "7px",
                                height: "8.6vh",
                                width: "100%",
                                cursor: "pointer",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "row",
                                  color: "#fff",
                                }}
                              >
                                Create Advance
                              </div>
                            </button>
                          </Col>
                        ) : null}

                        {showPayments.length < filteredPaymentMethods.length && (
                          <Col span={8}>
                            <button
                              onClick={isShowingAll ? showPreviousItems : showMoreItems}
                              style={{
                                backgroundColor: "#046307C2",
                                border: "1px solid #fff",
                                borderRadius: "7px",
                                height: "8.6vh",
                                width: "100%",
                                cursor: "pointer",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "row",
                                }}
                              >
                                <img style={{ height: "2.5vh", left: "0.5em" }} color={"#fff"} />
                                <span className="payment" style={{ color: "#fff", marginLeft: "0.25em" }}>
                                  ...
                                </span>
                              </div>
                            </button>
                          </Col>
                        )}
                      </Row>
                      <div
                        style={{
                          background: "#fff",
                          height: "23vh",
                          width: "95%",
                          margin: "0.75% 1% 2.7% 3.5%",
                          border: "1px solid #fff",
                          borderRadius: "7px",
                        }}
                      >
                        <Row
                          style={{
                            height: "3vh",
                            marginTop: "3%",
                            fontSize: "1vw",
                          }}
                        >
                          <Col span={12} style={styles.screenStyles.mainScreen.card}>
                            <p style={{ margin: "0" }}>Amount Tendered</p>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingRight: "1vw",
                              textAlign: "right",
                              justifyContent: "end",
                            }}
                          >
                            <p
                              style={{
                                textAlign: "right",
                                margin: "0",
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                              }}
                            >
                              {parseFloat(cart.total).toFixed(pricePrecision)}
                            </p>
                          </Col>
                        </Row>

                        <Row style={{ height: "3vh", fontSize: "1vw" }}>
                          <Col span={12} style={styles.screenStyles.mainScreen.card}>
                            <p style={{ margin: "0" }}>Change</p>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingRight: "1vw",
                              textAlign: "right",
                              justifyContent: "end",
                            }}
                          >
                            <p
                              style={{
                                textAlign: "right",
                                margin: "0",
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                              }}
                            >
                              {(cart.paid ?? 0) + parseFloat(amount) - Math.abs(cart.total) > 0
                                ? ((cart.paid ?? 0) + parseFloat(amount) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                                : cart?.change <= 0
                                  ? "0.00"
                                  : cart?.change}
                            </p>
                          </Col>
                        </Row>

                        <Row style={{ height: "3vh", fontSize: "1vw" }}>
                          <Col span={12} style={styles.screenStyles.mainScreen.card}>
                            <p style={{ margin: "0" }}>Overpayment</p>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingRight: "1vw",
                              textAlign: "right",
                              justifyContent: "end",
                            }}
                          >
                            <p
                              style={{
                                textAlign: "right",
                                margin: "0",
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                              }}
                            >
                              {Math.abs(overPayedAmount).toFixed(pricePrecision)}
                            </p>
                          </Col>
                        </Row>

                        <Row style={{ height: "3vh", fontSize: "1vw" }}>
                          <Col span={12} style={styles.screenStyles.mainScreen.card}>
                            <p style={{ margin: "0" }}>Remaining Due</p>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingRight: "1vw",
                              textAlign: "right",
                              justifyContent: "end",
                            }}
                          >
                            <p
                              style={{
                                textAlign: "right",
                                margin: "0",
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                              }}
                            >
                              {parseFloat(Math.abs(cart.total)) >= parseFloat(cart.paid) ? parseFloat(Math.abs(cart.total) - cart.paid).toFixed(pricePrecision) : 0}
                            </p>
                          </Col>
                        </Row>
                        <hr style={{ margin: "1vh 1vw" }} />
                        <Scrollbars style={{ height: "6.3vh" }}>
                          {cart?.advancePayment > 0 &&
                            cart.layAway === "Y" &&
                            cart?.paymentData?.map((item) => {
                              return (
                                <Row style={{ fontSize: "1vw" }}>
                                  <Col
                                    span={12}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      paddingLeft: "0.8vw",
                                      fontWeight: "450",
                                      textAlign: "left",
                                    }}
                                  >
                                    <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" ? `${item.name} - ${item.authorizationCode}` : item.name}</p>
                                  </Col>
                                  <Col
                                    span={12}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      paddingRight: "1vw",
                                      textAlign: "right",
                                      justifyContent: "end",
                                    }}
                                  >
                                    {/* {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                                  &nbsp; */}
                                    <p
                                      style={{
                                        textAlign: "right",
                                        margin: "0",
                                        fontWeight: "500",
                                        paddingRight: "1.2vw",
                                      }}
                                    >
                                      {" "}
                                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                      &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                    </p>
                                  </Col>
                                </Row>
                              );
                            })}
                          {cart.payments.map((item) => {
                            return (
                              <Row style={{ fontSize: "1vw" }}>
                                <Col
                                  span={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingLeft: "0.8vw",
                                    fontWeight: "450",
                                    textAlign: "left",
                                  }}
                                >
                                  <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" ? `${item.name} - ${item.authorization}` : item.name}</p>
                                </Col>
                                <Col
                                  span={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingRight: "1vw",
                                    textAlign: "right",
                                    justifyContent: "end",
                                  }}
                                >
                                  {/* {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                                  &nbsp; */}
                                  <p
                                    style={{
                                      textAlign: "right",
                                      margin: "0",
                                      fontWeight: "500",
                                      paddingRight: "1.2vw",
                                    }}
                                  >
                                    {" "}
                                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                    &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                  </p>
                                  <img
                                    src={DeleteProduct}
                                    onClick={() => handleDeletePayment(item)}
                                    style={{
                                      height: "15px",
                                      width: "15px",
                                      cursor: "pointer",
                                      marginLeft: "1vw",
                                      position: "absolute",
                                      right: 5,
                                      top: "15%",
                                    }}
                                  />
                                  {/* <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span> */}
                                </Col>
                              </Row>
                            );
                          })}
                        </Scrollbars>
                      </div>
                      <Row style={{ margin: "0 0 0 0 " }}>
                        <Input
                          className="productSearch sm-payment-search totalInput"
                          style={{
                            borderRadius: "0.5vw",
                            height: "7.3vh",
                            margin: "0 1% 2.7% 3.5%",
                            borderRadius: "5px",
                            textAlign: "right",
                            fontWeight: "500",
                            fontSize: "2.5em",
                            borderColor: "#fff",
                            color: "#2F3856",
                          }}
                          // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
                          value={amount}
                          // type="number"
                          id="sm-total-amount-input"
                          onChange={onChangeAmount}
                          placeholder="Enter Amount"
                          ref={paymentModalInputRef}
                          onFocus={() => {
                            setIsInputFocused(true);
                          }}
                          onBlur={() => {
                            setIsInputFocused(false);
                          }}
                          readOnly={cart.items.length > 0 ? false : true}
                          disabled={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? true : false}
                          onPressEnter={async () => {
                            if (
                              selectedPaymentMethod?.name?.toLowerCase() === "cash" &&
                              parseFloat(cart.paid) + parseFloat(amount) >= cart.total &&
                              posConfig?.showPaymentSummary === "Y" &&
                              !(await showConfirm())
                            ) {
                              return;
                            }
                            const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                            const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
                            if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                              if (result !== 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
                                {
                                  message.warning(`${messages.warnings.payment.payment_multiple_check} ${filtredCurrencies[0]?.value}`);
                                }
                              } else {
                                requestPayment(selectedPaymentMethod, amount);
                              }
                            }
                            // else if (cart?.docType !== "Advance") {
                            //   processOrder();
                            // }
                          }}
                        />
                      </Row>
                      {denaminationsKeyboard && selectedPaymentMethod?.name?.toLowerCase() === "cash" ? (
                        <Row style={{ padding: "0 1% 0 3.5%" }}>
                          <Col span={18}>
                            <Row gutter={[8, 5]} style={{ display: "flex", flexDirection: "row-reverse" }}>
                              {currenciesData.map((currency) => (
                                <Col span={8}>
                                  <button
                                    id={`sm-amount-button${currenciesData.indexOf(currency) + 1}`}
                                    className="amt-dial-btn-market"
                                    onClick={() => handleCashPayment(currency.value)}
                                    disabled={currency.value === 999999}
                                    style={{
                                      color: currency.value !== 999999 ? "#0f0718" : "transparent",
                                    }}
                                  >
                                    {currency.value}
                                  </button>
                                </Col>
                              ))}
                            </Row>
                          </Col>

                          <Col span={6}>
                            <Row style={{ padding: "0 0 7% 7%" }}>
                              <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleAmount("x")}>
                                <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                              </button>
                            </Row>
                            <Row style={{ padding: "0 0 7% 7%" }}>
                              <button id="sm-amount-buttonClear" className="amt-dial-btn-market" onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}>
                                1,2,3...
                              </button>
                            </Row>
                            <Row style={{ padding: "0 0 0 7%" }}>
                              <button
                                id="sm-amount-buttonEnter"
                                className="amt-dial-btn-market2"
                                onClick={async () => {
                                  if (amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
                                    message.warning(`${messages.warnings.payment.refund_amount}`);
                                    return;
                                  }
                                  if (
                                    selectedPaymentMethod?.name?.toLowerCase() === "cash" &&
                                    parseFloat(cart.paid) + parseFloat(amount) >= cart.total &&
                                    posConfig?.showPaymentSummary === "Y" &&
                                    !(await showConfirm())
                                  ) {
                                    return;
                                  }
                                  const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                                  const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
                                  const isGiftCardOrLoyalty =
                                    selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                                    selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                                    selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                                  if (isGiftCardOrLoyalty) {
                                    if (parseFloat(Math.abs(cart.total)) > parseFloat(Math.abs(cart.paid))) {
                                      if (result !== 0) {
                                        message.warning(`${messages.warnings.payment.payment_multiple_check} ${filtredCurrencies[0]?.value}`);
                                      } else {
                                        requestPayment(selectedPaymentMethod, amount);
                                        if (parseFloat(Math.abs(cart.total)) > parseFloat(amount)) {
                                          if (CWHardwareController) {
                                            CWPoleDisplay(cart, "Show due payment", amount);
                                          } else {
                                            PoleDisplay(cart, "Show due payment", amount);
                                          }
                                        }
                                      }
                                    }
                                    //  else if (cart?.docType !== "Advance") {
                                    //   processOrder();
                                    // }
                                  }
                                }}
                              >
                                Enter
                              </button>
                            </Row>
                          </Col>
                        </Row>
                      ) : (
                        <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                          <Col span={6}>
                            <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("1")}>
                              1
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("2")}>
                              2
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("3")}>
                              3
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} id="sm-amount-buttonRemove" onClick={() => handleAmount("x")}>
                              <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("4")}>
                              4
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("5")}>
                              5
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("6")}>
                              6
                            </button>
                          </Col>
                          <Col span={6}>
                            <button
                              id="sm-amount-buttonClear"
                              className="amt-dial-btn-market"
                              style={{ background: themeJSON?.keyBoardColor }}
                              onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}
                            >
                              1,2,3...
                            </button>
                          </Col>
                          <Col span={18}>
                            <Row gutter={[8, 6]}>
                              <Col span={8}>
                                <button id="sm-amount-button7" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("7")}>
                                  7
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button8" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("8")}>
                                  8
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("9")}>
                                  9
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("0")}>
                                  0
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button00" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("00")}>
                                  00
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button." className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount(".")}>
                                  .
                                </button>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={6}>
                            <button
                              id="sm-amount-buttonEnter"
                              className="amt-dial-btn-market2"
                              style={{ background: themeJSON?.keyBoardColor }}
                              onClick={async () => {
                                if (
                                  selectedPaymentMethod?.name?.toLowerCase() === "cash" &&
                                  parseFloat(cart.paid) + parseFloat(amount) >= cart.total &&
                                  posConfig?.showPaymentSummary === "Y" &&
                                  !(await showConfirm())
                                ) {
                                  return;
                                }

                                const isGiftCardOrLoyalty =
                                  selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                                  selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                                  selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                                const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                                const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
                                if (isGiftCardOrLoyalty) {
                                  if (parseFloat(Math.abs(cart.total)) > parseFloat(cart?.paid)) {
                                    if (result !== 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
                                      {
                                        message.warning(`${t("cash_payment_error")}`);
                                      }
                                    } else {
                                      setNumb(0);
                                      // Handle successful entry, e.g., submit the amount
                                      requestPayment(selectedPaymentMethod, amount);
                                    }
                                  }
                                }
                                // else if (cart?.docType !== "Advance") {
                                //   processOrder();
                                // }
                              }}
                            >
                              Enter
                            </button>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </div>
                </div>
                <RetailModals {...props} selectBagRef={selectBagRef} />
              </div>
            </>
          )}
        </div>

        <Drawer
          placement="left"
          width="20%"
          closable={false}
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={POSLogo} style={{ height: "2vw", cursor: "pointer" }} />
              {/* <p style={{ fontSize: "2vw", paddingTop: "3vh", fontWeight: "500", color: "#2F3856", flex: 1, textAlign: "center" }}>Add Discount</p> */}
              <img
                src={Close}
                onClick={() => {
                  (setTillLink(false), setActiveInput("search"), setSelectedDocumentType("Invoice"));
                  if (searchInputRef?.current) {
                    searchInputRef?.current.focus();
                  }
                }}
                // style={{ marginLeft: "auto", paddingBottom: "5vh", cursor: "pointer" }}
                style={{
                  marginLeft: "auto",
                  // paddingBottom: "4vh",
                  paddingTop: "2vh",
                  cursor: "pointer",
                  width: "1.5vw",
                }}
              />
            </div>
          }
          bodyStyle={{ paddingTop: 0 }}
          visible={tillLink}
          onClose={() => setTillLink(false)}
        >
          <Row gutter={[16, 16]} style={{ fontSize: "1vw" }}>
            <Col span={24}>
              <Scrollbars style={{ height: "80vh" }}>
                <Row>
                  <Col
                    span={1}
                    style={{
                      cursor: "pointer",
                      display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                    }}
                  />
                  {/* <Col
                    // onClick={tillUnlink}
                    onClick={confirmUnlink}
                    style={{
                      cursor: "pointer",
                      display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                      marginBottom: "2vh",
                    }}
                    span={22}
                  >
                    <img src={unlinkTillIcon} style={{ height: "2.5vh" }} alt="" />
                    <span
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "1.2em",
                        paddingLeft: "1vw",
                        color: "#0F0718",
                      }}
                    >
                      Unlink Till
                    </span>
                  </Col> */}
                  <Col
                    span={1}
                    style={{
                      cursor: "pointer",
                      display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                    }}
                  />
                </Row>
              </Scrollbars>
            </Col>
            <Col
              span={24}
              style={{
                width: "80%",
                // borderTop: "1px solid #929098",
                position: "absolute",
                bottom: "2.5vh",
                padding: "1vh 1vw",
              }}
            >
              <Row>
                <Col span={1} />

                {/* <Col
                  style={{ cursor: "pointer", paddingTop: "1vh" }}
                  onClick={async () => {
                    // if (posConfigData?.posType === "PRD") {
                    const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
                    for (let i = 0; i < cookiesToDelete.length; i++) {
                      const cookie = cookiesToDelete[i];
                      const eqPos = cookie.indexOf("=");
                      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                      const domain = "domain=" + domainURL;
                      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
                    }
                    localStorage.removeItem("tillSession");
                    window.location.assign("/");
                    // }
                    handleCancel();
                  }}
                  span={20}
                >
                  <img src={Logout} alt="" />
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "1.2em",
                      color: "#0F0718",
                    }}
                  >
                    Logout
                  </span>
                </Col> */}
                <Col span={24} style={{ position: "absolute", bottom: "0.5vh", right: "0" }}>
                  <p style={{ color: "#0f071840", textAlign: "right", paddingRight: "1vw", fontSize: "0.6rem", fontWeight: 400 }}>v{version_number}</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Drawer>
        <Drawer
          placement="bottom"
          height="75vh"
          title={null}
          closeIcon={null}
          className="filter"
          headerStyle={{ height: 0 }}
          bodyStyle={{ paddingTop: 0 }}
          visible={isProductsVisible}
          closable={true}
          onClose={closeProductPanel}
          footer={null}
        >
          <Row
            style={{
              paddingTop: isQtyUpdate ? 0 : "1.7%",
              width: "100%",
              paddingLeft: "1vw",
            }}
          >
            <ProductPanelSM
              checkIsManualWeight={checkIsManualWeight}
              setIsSearchProducts={setIsSearchProducts}
              getMoreProducts={getMoreProducts}
              productItems={productItems}
              setProductItems={setProductItems}
              selectProductInCart={selectProductInCart}
              setProductArray={setProductArray}
              isProductsFilter={isProductsFilter}
              getSearchedProducts={getSearchedProducts}
              productListCardRef={productListCardRef}
              productsDisplay={productsDisplay}
              setIsProductsVisible={setIsProductsVisible}
              pickProduct={pickProduct}
              filterDrawer={filterDrawer}
              setFilterDrawer={setFilterDrawer}
              productSearchInput={productSearchInput}
              setProductSearchInput={setProductSearchInput}
              setOpen={setOpen}
              keyboardType={keyboardType}
              setKeyboardType={setKeyboardType}
              productSearchInputRef={productSearchInputRef}
              clearProductSearchResults={clearProductSearchResults}
              productsData={productsData}
              setProductsData={setProductsData}
              isProductsVisible={isProductsVisible}
              productSearchRef={productSearchRef}
              handleSelectProduct={handleSelectProduct}
              productsList={productsList}
              setProductsList={setProductsList}
              setLayoutName={setLayoutName}
              productPanelSearchRef={productPanelSearchRef}
              setInputName={setInputName}
              keyboard={keyboard}
              searchInputRef={searchInputRef}
              setCart={setCart}
            />
          </Row>
        </Drawer>
        <ProductPanelSM
          checkIsManualWeight={checkIsManualWeight}
          setIsSearchProducts={setIsSearchProducts}
          getMoreProducts={getMoreProducts}
          productItems={productItems}
          setProductItems={setProductItems}
          selectProductInCart={selectProductInCart}
          isProductsFilter={isProductsFilter}
          getSearchedProducts={getSearchedProducts}
          productListCardRef={productListCardRef}
          productsDisplay={productsDisplay}
          isProductsVisible={isProductsVisible}
          setIsProductsVisible={setIsProductsVisible}
          pickProduct={pickProduct}
          filterDrawer={filterDrawer}
          setFilterDrawer={setFilterDrawer}
          productSearchInput={productSearchInput}
          setProductSearchInput={setProductSearchInput}
          setOpen={setOpen}
          keyboardType={keyboardType}
          setKeyboardType={setKeyboardType}
          productSearchInputRef={productSearchInputRef}
          clearProductSearchResults={clearProductSearchResults}
          productsData={productsData}
          setProductsData={setProductsData}
          productSearchRef={productSearchRef}
          handleSelectProduct={handleSelectProduct}
          productsList={productsList}
          setProductsList={setProductsList}
          setLayoutName={setLayoutName}
          productPanelSearchRef={productPanelSearchRef}
          setInputName={setInputName}
          keyboard={keyboard}
          searchInputRef={searchInputRef}
          setCart={setCart}
        />
        <GroupedProducts
          showCustomMix={showCustomMix}
          setShowCustomMix={setShowCustomMix}
          cart={cart}
          setCart={setCart}
          customMixItems={customMixItems}
          setCustomMixItems={setCustomMixItems}
          groupName={groupName}
          setGroupName={setGroupName}
          groupQty={groupQty}
          setGroupQty={setGroupQty}
          existingGroupItems={existingGroupItems}
          setExistingGroupItems={setExistingGroupItems}
          selectedCustomMix={selectedCustomMix}
          setSelectedCustomMix={setSelectedCustomMix}
          orderType={orderType}
          setOrderType={setOrderType}
          posSaleTypes={posSaleTypes}
          setPosSaleTypes={setPosSaleTypes}
          currenciesData={currenciesData}
          setCurrenciesData={setCurrenciesData}
          searchInputRef={searchInputRef}
          setActiveInput={setActiveInput}
          setProductStock={setProductStock}
          setCompleteSaleStockData={setCompleteSaleStockData}
        />
      </>
    </Spin>
  );
};
export default SupermarketPreorder;
